const geojsonData = {
  type: "FeatureCollection",

  features: [
    
    {
      type: "Feature",
      id: "sm1d8a5c75",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091819834, 40.700970975],
            [-74.088988495, 40.700973198],
            [-74.088216018, 40.701558828],
            [-74.088237476, 40.705739423],
            [-74.088237476, 40.705739423],
            [-74.091826366, 40.705751715],
            [-74.091819834, 40.700970975],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1264",
      },
    },
    {
      type: "Feature",
      id: "sm5e8d7a85",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091826366, 40.705751715],
            [-74.094916285, 40.705762298],
            [-74.094909735, 40.700968548],
            [-74.091819834, 40.700970975],
            [-74.091826366, 40.705751715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1263",
      },
    },
    {
      type: "Feature",
      id: "sm5f562d5c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.094916285, 40.705762298],
            [-74.098328582, 40.705773985],
            [-74.098322013, 40.700965869],
            [-74.094909735, 40.700968548],
            [-74.094916285, 40.705762298],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1262",
      },
    },
    {
      type: "Feature",
      id: "smee6b6b1e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.098328582, 40.705773985],
            [-74.101396776, 40.705784494],
            [-74.10139019, 40.70096346],
            [-74.098322013, 40.700965869],
            [-74.098328582, 40.705773985],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1261",
      },
    },
    {
      type: "Feature",
      id: "sm913d7dd3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.101396776, 40.705784494],
            [-74.104830086, 40.705796253],
            [-74.10482348, 40.700960764],
            [-74.10139019, 40.70096346],
            [-74.101396776, 40.705784494],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1260",
      },
    },
    {
      type: "Feature",
      id: "smec1e3b00",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.104830086, 40.705796253],
            [-74.107898437, 40.705806762],
            [-74.107891813, 40.700958355],
            [-74.10482348, 40.700960764],
            [-74.104830086, 40.705796253],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1259",
      },
    },
    {
      type: "Feature",
      id: "smf2f66b70",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.107898437, 40.705806762],
            [-74.111224414, 40.705818153],
            [-74.111217771, 40.700955744],
            [-74.107891813, 40.700958355],
            [-74.107898437, 40.705806762],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1258",
      },
    },
    {
      type: "Feature",
      id: "sm82bf5500",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.111224414, 40.705818153],
            [-74.114368118, 40.70582892],
            [-74.114397175, 40.700953248],
            [-74.111217771, 40.700955744],
            [-74.111224414, 40.705818153],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1257",
      },
    },
    {
      type: "Feature",
      id: "smd5bb3300",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.114368118, 40.70582892],
            [-74.117757779, 40.70584053],
            [-74.117786922, 40.700950586],
            [-74.114397175, 40.700953248],
            [-74.114368118, 40.70582892],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1256",
      },
    },
    {
      type: "Feature",
      id: "smd5f6b079",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117757779, 40.70584053],
            [-74.120869757, 40.705851188],
            [-74.120898977, 40.700948142],
            [-74.117786922, 40.700950586],
            [-74.117757779, 40.70584053],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1255",
      },
    },
    {
      type: "Feature",
      id: "smac3e731d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.120869757, 40.705851188],
            [-74.124219024, 40.705862659],
            [-74.124248329, 40.700945512],
            [-74.120898977, 40.700948142],
            [-74.120869757, 40.705851188],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1254",
      },
    },
    {
      type: "Feature",
      id: "sme30d01c4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.124219024, 40.705862659],
            [-74.127652182, 40.705874418],
            [-74.127681573, 40.700942816],
            [-74.124248329, 40.700945512],
            [-74.124219024, 40.705862659],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1253",
      },
    },
    {
      type: "Feature",
      id: "smb699bb50",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127652182, 40.705874418],
            [-74.130981159, 40.70588582],
            [-74.131002616, 40.701363619],
            [-74.130423259, 40.700940663],
            [-74.127681573, 40.700942816],
            [-74.127652182, 40.705874418],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1252",
      },
    },
    {
      type: "Feature",
      id: "sm1be4416a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020735834, 40.700926205],
            [-74.018242547, 40.700924393],
            [-74.017234037, 40.701705232],
            [-74.017212579, 40.705706888],
            [-74.017212579, 40.705706888],
            [-74.020727968, 40.70571021],
            [-74.020735834, 40.700926205],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1285",
      },
    },
    {
      type: "Feature",
      id: "sme610c7f1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020727968, 40.70571021],
            [-74.024161671, 40.705713455],
            [-74.024169539, 40.7009287],
            [-74.020735834, 40.700926205],
            [-74.020727968, 40.70571021],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1284",
      },
    },
    {
      type: "Feature",
      id: "smede36b6e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024161671, 40.705713455],
            [-74.027294568, 40.705716415],
            [-74.027300618, 40.700930975],
            [-74.024169539, 40.7009287],
            [-74.024161671, 40.705713455],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1283",
      },
    },
    {
      type: "Feature",
      id: "smfc78032c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.027294568, 40.705716415],
            [-74.030555965, 40.705719497],
            [-74.030562017, 40.700933345],
            [-74.027300618, 40.700930975],
            [-74.027294568, 40.705716415],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1282",
      },
    },
    {
      type: "Feature",
      id: "sm4968951d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.030555965, 40.705719497],
            [-74.033817733, 40.705722579],
            [-74.033823785, 40.700935715],
            [-74.030562017, 40.700933345],
            [-74.030555965, 40.705719497],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1281",
      },
    },
    {
      type: "Feature",
      id: "smaf98ec43",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.033817733, 40.705722579],
            [-74.037207754, 40.705725782],
            [-74.037213807, 40.700938178],
            [-74.033823785, 40.700935715],
            [-74.033817733, 40.705722579],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1280",
      },
    },
    {
      type: "Feature",
      id: "smdca90197",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037207754, 40.705725782],
            [-74.040296955, 40.705728701],
            [-74.040303009, 40.700940423],
            [-74.037213807, 40.700938178],
            [-74.037207754, 40.705725782],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1279",
      },
    },
    {
      type: "Feature",
      id: "sma0ca55fd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040296955, 40.705728701],
            [-74.043643731, 40.705731863],
            [-74.043649786, 40.700942855],
            [-74.040303009, 40.700940423],
            [-74.040296955, 40.705728701],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1278",
      },
    },
    {
      type: "Feature",
      id: "smcd4013ea",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043643731, 40.705731863],
            [-74.046775766, 40.705734823],
            [-74.046781822, 40.700945131],
            [-74.043649786, 40.700942855],
            [-74.043643731, 40.705731863],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1277",
      },
    },
    {
      type: "Feature",
      id: "smab4dd71a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046775766, 40.705734823],
            [-74.050080285, 40.705737946],
            [-74.050086341, 40.700947532],
            [-74.046781822, 40.700945131],
            [-74.046775766, 40.705734823],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1276",
      },
    },
    {
      type: "Feature",
      id: "sm4f908710",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.050080285, 40.705737946],
            [-74.053213307, 40.705740907],
            [-74.053219364, 40.700949809],
            [-74.050086341, 40.700947532],
            [-74.050080285, 40.705737946],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1275",
      },
    },
    {
      type: "Feature",
      id: "sm6fc3506a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053213307, 40.705740907],
            [-74.056603533, 40.705744111],
            [-74.056609591, 40.700952273],
            [-74.053219364, 40.700949809],
            [-74.053213307, 40.705740907],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1274",
      },
    },
    {
      type: "Feature",
      id: "sm30e1a44b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.056603533, 40.705744111],
            [-74.059566133, 40.705746911],
            [-74.059574013, 40.700954427],
            [-74.056609591, 40.700952273],
            [-74.056603533, 40.705744111],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1273",
      },
    },
    {
      type: "Feature",
      id: "smfe2243d2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059566133, 40.705746911],
            [-74.062999309, 40.705750155],
            [-74.063005369, 40.70095692],
            [-74.059574013, 40.700954427],
            [-74.059566133, 40.705746911],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1272",
      },
    },
    {
      type: "Feature",
      id: "sm3c292946",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062999309, 40.705750155],
            [-74.066431751, 40.705753399],
            [-74.066437812, 40.700959414],
            [-74.063005369, 40.70095692],
            [-74.062999309, 40.705750155],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1271",
      },
    },
    {
      type: "Feature",
      id: "sme931bd18",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.066431751, 40.705753399],
            [-74.069607277, 40.7057564],
            [-74.069613339, 40.700961722],
            [-74.066437812, 40.700959414],
            [-74.066431751, 40.705753399],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1270",
      },
    },
    {
      type: "Feature",
      id: "sm789a5b91",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069607277, 40.7057564],
            [-74.072914629, 40.705759525],
            [-74.072922514, 40.700964127],
            [-74.069613339, 40.700961722],
            [-74.069607277, 40.7057564],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1269",
      },
    },
    {
      type: "Feature",
      id: "smad7fd85d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072914629, 40.705759525],
            [-74.07600386, 40.705762444],
            [-74.076011746, 40.700966372],
            [-74.072922514, 40.700964127],
            [-74.072914629, 40.705759525],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1268",
      },
    },
    {
      type: "Feature",
      id: "sma51d618d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07600386, 40.705762444],
            [-74.079393926, 40.705765648],
            [-74.079401814, 40.700968835],
            [-74.076011746, 40.700966372],
            [-74.07600386, 40.705762444],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1267",
      },
    },
    {
      type: "Feature",
      id: "smf7e114ab",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.079393926, 40.705765648],
            [-74.082483345, 40.705768567],
            [-74.082489411, 40.700971079],
            [-74.079401814, 40.700968835],
            [-74.079393926, 40.705765648],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1266",
      },
    },
    {
      type: "Feature",
      id: "smc351883d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.082483345, 40.705768567],
            [-74.086070251, 40.705771956],
            [-74.086070251, 40.701526293],
            [-74.085405063, 40.700973198],
            [-74.082489411, 40.700971079],
            [-74.082483345, 40.705768567],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1265",
      },
    },
    {
      type: "Feature",
      id: "sm3d4bec21",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.975835832, 40.64399972],
            [-73.975756355, 40.626833249],
            [-73.930180258, 40.627028676],
            [-73.938235664, 40.644099957],
            [-73.975835832, 40.64399972],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1834",
      },
    },
    {
      type: "Feature",
      id: "sm82e72456",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.938235664, 40.644099957],
            [-73.948554094, 40.665960736],
            [-73.975937199, 40.665887761],
            [-73.975835832, 40.64399972],
            [-73.938235664, 40.644099957],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1833",
      },
    },
    {
      type: "Feature",
      id: "sm5cbd0828",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.948554094, 40.665960736],
            [-73.967430776, 40.705934616],
            [-73.967430776, 40.705934616],
            [-73.976238494, 40.705895745],
            [-73.976200568, 40.700957058],
            [-73.976099678, 40.700956929],
            [-73.975937199, 40.665887761],
            [-73.948554094, 40.665960736],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1832",
      },
    },
    {
      type: "Feature",
      id: "sm099aeab1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.976238494, 40.705895745],
            [-73.981732721, 40.705871498],
            [-73.981695035, 40.700964066],
            [-73.976200568, 40.700957058],
            [-73.976238494, 40.705895745],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1296",
      },
    },
    {
      type: "Feature",
      id: "smd51c86e7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981732721, 40.705871498],
            [-73.985165083, 40.70585635],
            [-73.985127546, 40.700968445],
            [-73.981695035, 40.700964066],
            [-73.981732721, 40.705871498],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1295",
      },
    },
    {
      type: "Feature",
      id: "sm98aadb8d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.985165083, 40.70585635],
            [-73.988108631, 40.705843359],
            [-73.988119442, 40.700972261],
            [-73.985127546, 40.700968445],
            [-73.985165083, 40.70585635],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1294",
      },
    },
    {
      type: "Feature",
      id: "sm25bfee8f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.988108631, 40.705843359],
            [-73.991497822, 40.705828402],
            [-73.99150859, 40.700976584],
            [-73.988119442, 40.700972261],
            [-73.988108631, 40.705843359],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1293",
      },
    },
    {
      type: "Feature",
      id: "smde989e11",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991497822, 40.705828402],
            [-73.994844024, 40.705813634],
            [-73.99485475, 40.700980852],
            [-73.99150859, 40.700976584],
            [-73.991497822, 40.705828402],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1292",
      },
    },
    {
      type: "Feature",
      id: "smf89c2bbf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994844024, 40.705813634],
            [-73.997979764, 40.705799795],
            [-73.99799045, 40.700984852],
            [-73.99485475, 40.700980852],
            [-73.994844024, 40.705813634],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1291",
      },
    },
    {
      type: "Feature",
      id: "sm3df5b134",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997979764, 40.705799795],
            [-74.00145493, 40.705784458],
            [-74.001465572, 40.700989285],
            [-73.99799045, 40.700984852],
            [-73.997979764, 40.705799795],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1290",
      },
    },
    {
      type: "Feature",
      id: "sm21848efa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00145493, 40.705784458],
            [-74.004501083, 40.705771014],
            [-74.004511687, 40.70099317],
            [-74.001465572, 40.700989285],
            [-74.00145493, 40.705784458],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1289",
      },
    },
    {
      type: "Feature",
      id: "sm63a92784",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004501083, 40.705771014],
            [-74.007847862, 40.705756244],
            [-74.007858424, 40.700997439],
            [-74.004511687, 40.70099317],
            [-74.004501083, 40.705771014],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1288",
      },
    },
    {
      type: "Feature",
      id: "sm4a8d75d3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007847862, 40.705756244],
            [-74.010937148, 40.70574261],
            [-74.01094767, 40.70100138],
            [-74.007858424, 40.700997439],
            [-74.007847862, 40.705756244],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1287",
      },
    },
    {
      type: "Feature",
      id: "smab8f0aea",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010937148, 40.70574261],
            [-74.015345762, 40.705723154],
            [-74.015345762, 40.701754034],
            [-74.014358709, 40.701005731],
            [-74.01094767, 40.70100138],
            [-74.010937148, 40.70574261],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1286",
      },
    },
    {
      type: "Feature",
      id: "smbdbad91f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119189639, 40.669457778],
            [-74.125222383, 40.669476531],
            [-74.125235949, 40.666965868],
            [-74.119823164, 40.666949041],
            [-74.119179434, 40.667600073],
            [-74.119189639, 40.669457778],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1309",
      },
    },
    {
      type: "Feature",
      id: "sm47fe90c6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.125075866, 40.696586597],
            [-74.119338601, 40.69656877],
            [-74.119351095, 40.698842111],
            [-74.119994825, 40.699427759],
            [-74.125060508, 40.699427759],
            [-74.125075866, 40.696586597],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1320",
      },
    },
    {
      type: "Feature",
      id: "sm6d09dfa9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119338601, 40.69656877],
            [-74.125075866, 40.696586597],
            [-74.1250909, 40.693805357],
            [-74.119323515, 40.693823578],
            [-74.119338601, 40.69656877],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1319",
      },
    },
    {
      type: "Feature",
      id: "sm82b7cae2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119323515, 40.693823578],
            [-74.1250909, 40.693805357],
            [-74.125104374, 40.691312506],
            [-74.119309617, 40.691294499],
            [-74.119323515, 40.693823578],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1318",
      },
    },
    {
      type: "Feature",
      id: "sm059bb68a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119309617, 40.691294499],
            [-74.125104374, 40.691312506],
            [-74.125119827, 40.688453521],
            [-74.119293906, 40.688435416],
            [-74.119309617, 40.691294499],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1317",
      },
    },
    {
      type: "Feature",
      id: "sm6de5f291",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119293906, 40.688435416],
            [-74.125119827, 40.688453521],
            [-74.125133996, 40.685831968],
            [-74.119279702, 40.685850465],
            [-74.119293906, 40.688435416],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1316",
      },
    },
    {
      type: "Feature",
      id: "smf4a861e3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119279702, 40.685850465],
            [-74.125133996, 40.685831968],
            [-74.125148965, 40.68306236],
            [-74.119264484, 40.683080953],
            [-74.119279702, 40.685850465],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1315",
      },
    },
    {
      type: "Feature",
      id: "sm738a53f6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119264484, 40.683080953],
            [-74.125148965, 40.68306236],
            [-74.125163281, 40.680413486],
            [-74.119249727, 40.680395106],
            [-74.119264484, 40.683080953],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1314",
      },
    },
    {
      type: "Feature",
      id: "sme0ef665c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119249727, 40.680395106],
            [-74.125163281, 40.680413486],
            [-74.12517789, 40.677710227],
            [-74.119234874, 40.677691755],
            [-74.119249727, 40.680395106],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1313",
      },
    },
    {
      type: "Feature",
      id: "sm5b9dee15",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119234874, 40.677691755],
            [-74.12517789, 40.677710227],
            [-74.125192663, 40.67497658],
            [-74.119219855, 40.674958014],
            [-74.119234874, 40.677691755],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1312",
      },
    },
    {
      type: "Feature",
      id: "smf3ef22a4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119219855, 40.674958014],
            [-74.125192663, 40.67497658],
            [-74.125207621, 40.672208537],
            [-74.119204648, 40.672189877],
            [-74.119219855, 40.674958014],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1311",
      },
    },
    {
      type: "Feature",
      id: "sm7b4cb9b6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119204648, 40.672189877],
            [-74.125207621, 40.672208537],
            [-74.125222383, 40.669476531],
            [-74.119189639, 40.669457778],
            [-74.119204648, 40.672189877],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1310",
      },
    },
    {
      type: "Feature",
      id: "sm9e6eae31",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131140799, 40.696595172],
            [-74.125075922, 40.696576327],
            [-74.125060508, 40.699427759],
            [-74.130037016, 40.699427759],
            [-74.131152815, 40.698777038],
            [-74.131140799, 40.696595172],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1297",
      },
    },
    {
      type: "Feature",
      id: "smab3ba1f9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.125222633, 40.669430375],
            [-74.130991328, 40.669448307],
            [-74.130981154, 40.667600073],
            [-74.130981154, 40.667600073],
            [-74.130294508, 40.666981593],
            [-74.125235949, 40.666965868],
            [-74.125222633, 40.669430375],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1308",
      },
    },
    {
      type: "Feature",
      id: "sme5558ddf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.130991328, 40.669448307],
            [-74.125222633, 40.669430375],
            [-74.125207683, 40.672197065],
            [-74.131006559, 40.67221509],
            [-74.130991328, 40.669448307],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1307",
      },
    },
    {
      type: "Feature",
      id: "sm7836e5bd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131006559, 40.67221509],
            [-74.125207683, 40.672197065],
            [-74.125192456, 40.675014879],
            [-74.131021871, 40.674996419],
            [-74.131006559, 40.67221509],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1306",
      },
    },
    {
      type: "Feature",
      id: "sm649fdeed",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131021871, 40.674996419],
            [-74.125192456, 40.675014879],
            [-74.125177841, 40.677719327],
            [-74.13103676, 40.677700775],
            [-74.131021871, 40.674996419],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1305",
      },
    },
    {
      type: "Feature",
      id: "sm197f643f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.13103676, 40.677700775],
            [-74.125177841, 40.677719327],
            [-74.125163422, 40.680387451],
            [-74.131051449, 40.680368807],
            [-74.13103676, 40.677700775],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1304",
      },
    },
    {
      type: "Feature",
      id: "smf46a09a3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131051449, 40.680368807],
            [-74.125163422, 40.680387451],
            [-74.125149279, 40.683004333],
            [-74.131066061, 40.683022722],
            [-74.131051449, 40.680368807],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1303",
      },
    },
    {
      type: "Feature",
      id: "sm1536a43a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131066061, 40.683022722],
            [-74.125149279, 40.683004333],
            [-74.12513416, 40.685801668],
            [-74.131081464, 40.685820151],
            [-74.131066061, 40.683022722],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1302",
      },
    },
    {
      type: "Feature",
      id: "sm15e4551b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131081464, 40.685820151],
            [-74.12513416, 40.685801668],
            [-74.125119717, 40.688473924],
            [-74.131096179, 40.688492497],
            [-74.131081464, 40.685820151],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1301",
      },
    },
    {
      type: "Feature",
      id: "sm686e7729",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131096179, 40.688492497],
            [-74.125119717, 40.688473924],
            [-74.125104232, 40.691338909],
            [-74.131111956, 40.691357578],
            [-74.131096179, 40.688492497],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1300",
      },
    },
    {
      type: "Feature",
      id: "sm0207b488",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131111956, 40.691357578],
            [-74.125104232, 40.691338909],
            [-74.125090696, 40.693843186],
            [-74.131125747, 40.69386194],
            [-74.131111956, 40.691357578],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1299",
      },
    },
    {
      type: "Feature",
      id: "smff44dfee",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131125747, 40.69386194],
            [-74.125090696, 40.693843186],
            [-74.125075922, 40.696576327],
            [-74.131140799, 40.696595172],
            [-74.131125747, 40.69386194],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1298",
      },
    },
    {
      type: "Feature",
      id: "sm40d52fe7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105234522, 40.669656858],
            [-74.11140152, 40.669676678],
            [-74.111416667, 40.666965318],
            [-74.105854221, 40.666965317],
            [-74.10521049, 40.667616349],
            [-74.105234522, 40.669656858],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1333",
      },
    },
    {
      type: "Feature",
      id: "sm7e0ae44e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11125117, 40.696584015],
            [-74.105551515, 40.696565704],
            [-74.105575271, 40.698581821],
            [-74.106390663, 40.699297615],
            [-74.111235917, 40.69931318],
            [-74.11125117, 40.696584015],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1344",
      },
    },
    {
      type: "Feature",
      id: "sm27c1d4e4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105551515, 40.696565704],
            [-74.11125117, 40.696584015],
            [-74.111266631, 40.693817651],
            [-74.105518919, 40.693799185],
            [-74.105551515, 40.696565704],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1343",
      },
    },
    {
      type: "Feature",
      id: "sm1751a0f5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105518919, 40.693799185],
            [-74.111266631, 40.693817651],
            [-74.11128082, 40.691278671],
            [-74.105489003, 40.691260062],
            [-74.105518919, 40.693799185],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1342",
      },
    },
    {
      type: "Feature",
      id: "smaaa37f9e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105489003, 40.691260062],
            [-74.11128082, 40.691278671],
            [-74.111296271, 40.68851374],
            [-74.105456426, 40.688494977],
            [-74.105489003, 40.691260062],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1341",
      },
    },
    {
      type: "Feature",
      id: "sme2993213",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105456426, 40.688494977],
            [-74.111296271, 40.68851374],
            [-74.111311351, 40.68581502],
            [-74.105424631, 40.685796106],
            [-74.105456426, 40.688494977],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1340",
      },
    },
    {
      type: "Feature",
      id: "sm564db3de",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105424631, 40.685796106],
            [-74.111311351, 40.68581502],
            [-74.111327, 40.683014425],
            [-74.105391637, 40.682995353],
            [-74.105424631, 40.685796106],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1339",
      },
    },
    {
      type: "Feature",
      id: "smd08e2b32",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105391637, 40.682995353],
            [-74.111327, 40.683014425],
            [-74.111341731, 40.680378089],
            [-74.105360579, 40.680358869],
            [-74.105391637, 40.682995353],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1338",
      },
    },
    {
      type: "Feature",
      id: "sm51219e06",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105360579, 40.680358869],
            [-74.111341731, 40.680378089],
            [-74.111356635, 40.67771062],
            [-74.105329156, 40.67769125],
            [-74.105360579, 40.680358869],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1337",
      },
    },
    {
      type: "Feature",
      id: "sm34937ecc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105329156, 40.67769125],
            [-74.111356635, 40.67771062],
            [-74.11137191, 40.674976709],
            [-74.105296951, 40.674957186],
            [-74.105329156, 40.67769125],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1336",
      },
    },
    {
      type: "Feature",
      id: "smc93cb2e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105296951, 40.674957186],
            [-74.11137191, 40.674976709],
            [-74.111387172, 40.672244892],
            [-74.105264772, 40.672225216],
            [-74.105296951, 40.674957186],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1335",
      },
    },
    {
      type: "Feature",
      id: "sm8412f10d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.105264772, 40.672225216],
            [-74.111387172, 40.672244892],
            [-74.11140152, 40.669676678],
            [-74.105234522, 40.669656858],
            [-74.105264772, 40.672225216],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1334",
      },
    },
    {
      type: "Feature",
      id: "sma9fd5ed2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117378474, 40.696629207],
            [-74.111251028, 40.696609522],
            [-74.111235917, 40.69931318],
            [-74.116518684, 40.699330151],
            [-74.117376991, 40.698777038],
            [-74.117378474, 40.696629207],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1321",
      },
    },
    {
      type: "Feature",
      id: "sm273cea39",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.111401762, 40.669633292],
            [-74.11739711, 40.669635672],
            [-74.117398448, 40.667697728],
            [-74.117398448, 40.667697728],
            [-74.116475768, 40.666965318],
            [-74.111416667, 40.666965318],
            [-74.111401762, 40.669633292],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1332",
      },
    },
    {
      type: "Feature",
      id: "sm4bcc47d5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11739711, 40.669635672],
            [-74.111401762, 40.669633292],
            [-74.111387215, 40.672237235],
            [-74.117395313, 40.67223962],
            [-74.11739711, 40.669635672],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1331",
      },
    },
    {
      type: "Feature",
      id: "smf36051cb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117395313, 40.67223962],
            [-74.111387215, 40.672237235],
            [-74.111371795, 40.674997119],
            [-74.117393397, 40.675016471],
            [-74.117395313, 40.67223962],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1330",
      },
    },
    {
      type: "Feature",
      id: "sm25ef4d7b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117393397, 40.675016471],
            [-74.111371795, 40.674997119],
            [-74.111356509, 40.677733099],
            [-74.117391508, 40.677752492],
            [-74.117393397, 40.675016471],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1329",
      },
    },
    {
      type: "Feature",
      id: "sm548a3e62",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117391508, 40.677752492],
            [-74.111356509, 40.677733099],
            [-74.1113414, 40.680437248],
            [-74.117389641, 40.680456684],
            [-74.117391508, 40.677752492],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1328",
      },
    },
    {
      type: "Feature",
      id: "sm45f9f73a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117389641, 40.680456684],
            [-74.1113414, 40.680437248],
            [-74.111326672, 40.683073168],
            [-74.117387821, 40.683092644],
            [-74.117389641, 40.680456684],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1327",
      },
    },
    {
      type: "Feature",
      id: "smeb59fd9c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117387821, 40.683092644],
            [-74.111326672, 40.683073168],
            [-74.111311581, 40.68577393],
            [-74.117385956, 40.685793448],
            [-74.117387821, 40.683092644],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1326",
      },
    },
    {
      type: "Feature",
      id: "sm5395115d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117385956, 40.685793448],
            [-74.111311581, 40.68577393],
            [-74.111296125, 40.688539802],
            [-74.117384046, 40.688559362],
            [-74.117385956, 40.685793448],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1325",
      },
    },
    {
      type: "Feature",
      id: "sm776810fc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117384046, 40.688559362],
            [-74.111296125, 40.688539802],
            [-74.111280843, 40.691274535],
            [-74.117382158, 40.691294138],
            [-74.117384046, 40.688559362],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1324",
      },
    },
    {
      type: "Feature",
      id: "sma576c229",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.117382158, 40.691294138],
            [-74.111280843, 40.691274535],
            [-74.111266296, 40.693877626],
            [-74.11738036, 40.693897269],
            [-74.117382158, 40.691294138],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1323",
      },
    },
    {
      type: "Feature",
      id: "smf2c44f27",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11738036, 40.693897269],
            [-74.111266296, 40.693877626],
            [-74.111251028, 40.696609522],
            [-74.117378474, 40.696629207],
            [-74.11738036, 40.693897269],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1322",
      },
    },
    {
      type: "Feature",
      id: "sm9ea24b8c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091374591, 40.669611842],
            [-74.097776415, 40.669652138],
            [-74.097806713, 40.666882942],
            [-74.092056937, 40.666900214],
            [-74.091370292, 40.667551246],
            [-74.091374591, 40.669611842],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1357",
      },
    },
    {
      type: "Feature",
      id: "sm901a323b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.09748095, 40.696651119],
            [-74.09143093, 40.696613052],
            [-74.091434665, 40.698402872],
            [-74.092292972, 40.699281349],
            [-74.097451804, 40.699313807],
            [-74.09748095, 40.696651119],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1368",
      },
    },
    {
      type: "Feature",
      id: "sm57dbd32b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.09143093, 40.696613052],
            [-74.09748095, 40.696651119],
            [-74.097509449, 40.694047459],
            [-74.091425496, 40.694009177],
            [-74.09143093, 40.696613052],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1367",
      },
    },
    {
      type: "Feature",
      id: "sm390cdce3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091425496, 40.694009177],
            [-74.097509449, 40.694047459],
            [-74.097539233, 40.691326238],
            [-74.091419817, 40.691287732],
            [-74.091425496, 40.694009177],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1366",
      },
    },
    {
      type: "Feature",
      id: "smee28cfc9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091419817, 40.691287732],
            [-74.097539233, 40.691326238],
            [-74.097570722, 40.688449096],
            [-74.091413813, 40.688410353],
            [-74.091419817, 40.691287732],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1365",
      },
    },
    {
      type: "Feature",
      id: "sm79020ecb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091413813, 40.688410353],
            [-74.097570722, 40.688449096],
            [-74.097600568, 40.685721976],
            [-74.091408122, 40.685683007],
            [-74.091413813, 40.688410353],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1364",
      },
    },
    {
      type: "Feature",
      id: "sm99342476",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091408122, 40.685683007],
            [-74.097600568, 40.685721976],
            [-74.097629767, 40.683053885],
            [-74.091402554, 40.683014696],
            [-74.091408122, 40.685683007],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1363",
      },
    },
    {
      type: "Feature",
      id: "smbfc084c3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091402554, 40.683014696],
            [-74.097629767, 40.683053885],
            [-74.097658425, 40.680435142],
            [-74.091397187, 40.680442655],
            [-74.091402554, 40.683014696],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1362",
      },
    },
    {
      type: "Feature",
      id: "sm8b6453b7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091397187, 40.680442655],
            [-74.097658425, 40.680435142],
            [-74.097687874, 40.677743987],
            [-74.091391474, 40.67770436],
            [-74.091397187, 40.680442655],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1361",
      },
    },
    {
      type: "Feature",
      id: "sm5a032027",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091391474, 40.67770436],
            [-74.097687874, 40.677743987],
            [-74.097718821, 40.674915821],
            [-74.091385573, 40.67487596],
            [-74.091391474, 40.67770436],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1360",
      },
    },
    {
      type: "Feature",
      id: "sm0f1dcaa7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091385573, 40.67487596],
            [-74.097718821, 40.674915821],
            [-74.097749453, 40.6721163],
            [-74.091379732, 40.672076208],
            [-74.091385573, 40.67487596],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1359",
      },
    },
    {
      type: "Feature",
      id: "smddc78429",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.091379732, 40.672076208],
            [-74.097749453, 40.6721163],
            [-74.097776415, 40.669652138],
            [-74.091374591, 40.669611842],
            [-74.091379732, 40.672076208],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1358",
      },
    },
    {
      type: "Feature",
      id: "sm989bcf68",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103662837, 40.696679754],
            [-74.097481062, 40.696640858],
            [-74.097451804, 40.699313807],
            [-74.10263557, 40.699346421],
            [-74.103665539, 40.698630627],
            [-74.103662837, 40.696679754],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1345",
      },
    },
    {
      type: "Feature",
      id: "smf6fd2aff",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.097777034, 40.66959555],
            [-74.10362539, 40.669632363],
            [-74.103622622, 40.667632625],
            [-74.103622622, 40.667632625],
            [-74.102893062, 40.666867662],
            [-74.097806713, 40.666882942],
            [-74.097777034, 40.66959555],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1356",
      },
    },
    {
      type: "Feature",
      id: "sm7ffb4286",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10362539, 40.669632363],
            [-74.097777034, 40.66959555],
            [-74.097748927, 40.672164378],
            [-74.103628946, 40.672201388],
            [-74.10362539, 40.669632363],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1355",
      },
    },
    {
      type: "Feature",
      id: "sm18053e43",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103628946, 40.672201388],
            [-74.097748927, 40.672164378],
            [-74.097717971, 40.674993471],
            [-74.103632863, 40.675030699],
            [-74.103628946, 40.672201388],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1354",
      },
    },
    {
      type: "Feature",
      id: "sm2311544b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103632863, 40.675030699],
            [-74.097717971, 40.674993471],
            [-74.097687704, 40.677759517],
            [-74.103636693, 40.677796958],
            [-74.103632863, 40.675030699],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1353",
      },
    },
    {
      type: "Feature",
      id: "sm23c77e84",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103636693, 40.677796958],
            [-74.097687704, 40.677759517],
            [-74.097657834, 40.680489123],
            [-74.103640472, 40.680526775],
            [-74.103636693, 40.677796958],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1352",
      },
    },
    {
      type: "Feature",
      id: "sm89be105d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103640472, 40.680526775],
            [-74.097657834, 40.680489123],
            [-74.097629585, 40.683070494],
            [-74.103644046, 40.683108344],
            [-74.103640472, 40.680526775],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1351",
      },
    },
    {
      type: "Feature",
      id: "smae9abe45",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103644046, 40.683108344],
            [-74.097629585, 40.683070494],
            [-74.097600074, 40.685767073],
            [-74.10364778, 40.685805131],
            [-74.103644046, 40.683108344],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1350",
      },
    },
    {
      type: "Feature",
      id: "sma9837ab5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10364778, 40.685805131],
            [-74.097600074, 40.685767073],
            [-74.097569863, 40.688527541],
            [-74.103651602, 40.688565811],
            [-74.10364778, 40.685805131],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1349",
      },
    },
    {
      type: "Feature",
      id: "sm0c1371ca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103651602, 40.688565811],
            [-74.097569863, 40.688527541],
            [-74.097539771, 40.691276958],
            [-74.103655409, 40.69131544],
            [-74.103651602, 40.688565811],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1348",
      },
    },
    {
      type: "Feature",
      id: "sm239b8ae9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103655409, 40.69131544],
            [-74.097539771, 40.691276958],
            [-74.097510228, 40.693976176],
            [-74.103659147, 40.694014866],
            [-74.103655409, 40.69131544],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1347",
      },
    },
    {
      type: "Feature",
      id: "sm6cfe88a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103659147, 40.694014866],
            [-74.097510228, 40.693976176],
            [-74.097481062, 40.696640858],
            [-74.103662837, 40.696679754],
            [-74.103659147, 40.694014866],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1346",
      },
    },
    {
      type: "Feature",
      id: "smd2420a8b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077625364, 40.669634505],
            [-74.083688445, 40.669634505],
            [-74.083688445, 40.666818834],
            [-74.078581518, 40.666818834],
            [-74.07763738, 40.667469867],
            [-74.077625364, 40.669634505],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1381",
      },
    },
    {
      type: "Feature",
      id: "sm62fac1b2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083688445, 40.696548271],
            [-74.077475929, 40.696548271],
            [-74.077465719, 40.698386603],
            [-74.07819528, 40.699297615],
            [-74.083688445, 40.699297615],
            [-74.083688445, 40.696548271],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1392",
      },
    },
    {
      type: "Feature",
      id: "sm2502bf1c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077475929, 40.696548271],
            [-74.083688445, 40.696548271],
            [-74.083688445, 40.694075392],
            [-74.077489662, 40.694075392],
            [-74.077475929, 40.696548271],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1391",
      },
    },
    {
      type: "Feature",
      id: "smab776310",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077489662, 40.694075392],
            [-74.083688445, 40.694075392],
            [-74.083688445, 40.691244483],
            [-74.077505383, 40.691244483],
            [-74.077489662, 40.694075392],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1390",
      },
    },
    {
      type: "Feature",
      id: "sm80b23305",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077505383, 40.691244483],
            [-74.083688445, 40.691244483],
            [-74.083688445, 40.68857616],
            [-74.0775202, 40.68857616],
            [-74.077505383, 40.691244483],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1389",
      },
    },
    {
      type: "Feature",
      id: "sm58f3db1d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0775202, 40.68857616],
            [-74.083688445, 40.68857616],
            [-74.083688445, 40.685712475],
            [-74.077536101, 40.685712475],
            [-74.0775202, 40.68857616],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1388",
      },
    },
    {
      type: "Feature",
      id: "sm55a0a33e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077536101, 40.685712475],
            [-74.083688445, 40.685712475],
            [-74.083688445, 40.683249882],
            [-74.077549883, 40.683230281],
            [-74.077536101, 40.685712475],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1387",
      },
    },
    {
      type: "Feature",
      id: "sm81078053",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077549883, 40.683230281],
            [-74.083688445, 40.683249882],
            [-74.083688445, 40.680472915],
            [-74.077565193, 40.680472915],
            [-74.077549883, 40.683230281],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1386",
      },
    },
    {
      type: "Feature",
      id: "sm7b20a90a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077565193, 40.680472915],
            [-74.083688445, 40.680472915],
            [-74.083688445, 40.677706521],
            [-74.077580552, 40.677706521],
            [-74.077565193, 40.680472915],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1385",
      },
    },
    {
      type: "Feature",
      id: "smca5d52f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077580552, 40.677706521],
            [-74.083688445, 40.677706521],
            [-74.083688445, 40.67497256],
            [-74.07759573, 40.67497256],
            [-74.077580552, 40.677706521],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1384",
      },
    },
    {
      type: "Feature",
      id: "smc8cbdd8f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07759573, 40.67497256],
            [-74.083688445, 40.67497256],
            [-74.083688445, 40.672173389],
            [-74.07761127, 40.672173389],
            [-74.07759573, 40.67497256],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1383",
      },
    },
    {
      type: "Feature",
      id: "smdc4d86c8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07761127, 40.672173389],
            [-74.083688445, 40.672173389],
            [-74.083688445, 40.669634505],
            [-74.077625364, 40.669634505],
            [-74.07761127, 40.672173389],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1382",
      },
    },
    {
      type: "Feature",
      id: "sm0f5ca847",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089688783, 40.696645882],
            [-74.083688445, 40.696645882],
            [-74.083688445, 40.699297615],
            [-74.089052862, 40.699297615],
            [-74.089696592, 40.698516748],
            [-74.089688783, 40.696645882],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1369",
      },
    },
    {
      type: "Feature",
      id: "sm0ab74417",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083688445, 40.669667055],
            [-74.089576198, 40.669667055],
            [-74.089567846, 40.667665175],
            [-74.089567846, 40.667665175],
            [-74.088709539, 40.666818834],
            [-74.083688445, 40.666818834],
            [-74.083688445, 40.669667055],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1380",
      },
    },
    {
      type: "Feature",
      id: "sm9077452a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089576198, 40.669667055],
            [-74.083688445, 40.669667055],
            [-74.083688445, 40.672271037],
            [-74.089587063, 40.672271037],
            [-74.089576198, 40.669667055],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1379",
      },
    },
    {
      type: "Feature",
      id: "sm5b3ae0cb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089587063, 40.672271037],
            [-74.083688445, 40.672271037],
            [-74.083688445, 40.674940012],
            [-74.089598199, 40.674940012],
            [-74.089587063, 40.672271037],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1378",
      },
    },
    {
      type: "Feature",
      id: "sm4d65cb4b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089598199, 40.674940012],
            [-74.083688445, 40.674940012],
            [-74.083688445, 40.677706521],
            [-74.089609743, 40.677706521],
            [-74.089598199, 40.674940012],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1377",
      },
    },
    {
      type: "Feature",
      id: "smcade7e52",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089609743, 40.677706521],
            [-74.083688445, 40.677706521],
            [-74.083688445, 40.680538005],
            [-74.089621558, 40.680538005],
            [-74.089609743, 40.677706521],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1376",
      },
    },
    {
      type: "Feature",
      id: "sm993d4ae7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089621558, 40.680538005],
            [-74.083688445, 40.680538005],
            [-74.083688445, 40.683271737],
            [-74.089632966, 40.683271737],
            [-74.089621558, 40.680538005],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1375",
      },
    },
    {
      type: "Feature",
      id: "smfe8d6bea",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089632966, 40.683271737],
            [-74.083688445, 40.683271737],
            [-74.083688445, 40.68577756],
            [-74.089643423, 40.68577756],
            [-74.089632966, 40.683271737],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1374",
      },
    },
    {
      type: "Feature",
      id: "sm8c253911",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089643423, 40.68577756],
            [-74.083688445, 40.68577756],
            [-74.083688445, 40.688641242],
            [-74.089655374, 40.688641242],
            [-74.089643423, 40.68577756],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1373",
      },
    },
    {
      type: "Feature",
      id: "sm3351957d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089655374, 40.688641242],
            [-74.083688445, 40.688641242],
            [-74.083688445, 40.691342102],
            [-74.089666646, 40.691342102],
            [-74.089655374, 40.688641242],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1372",
      },
    },
    {
      type: "Feature",
      id: "sm12555c0b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089666646, 40.691342102],
            [-74.083688445, 40.691342102],
            [-74.083688445, 40.69410793],
            [-74.08967819, 40.69410793],
            [-74.089666646, 40.691342102],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1371",
      },
    },
    {
      type: "Feature",
      id: "sm959e4b75",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.08967819, 40.69410793],
            [-74.083688445, 40.69410793],
            [-74.083688445, 40.696645882],
            [-74.089688783, 40.696645882],
            [-74.08967819, 40.69410793],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1370",
      },
    },
    {
      type: "Feature",
      id: "sme6f65ff6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072681145, 40.689761146],
            [-74.072705111, 40.694467352],
            [-74.075812943, 40.694458254],
            [-74.075792021, 40.690349626],
            [-74.075792021, 40.690349626],
            [-74.074998087, 40.689763898],
            [-74.072681145, 40.689761146],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1418",
      },
    },
    {
      type: "Feature",
      id: "sm3a21c391",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072705111, 40.694467352],
            [-74.072681145, 40.689761146],
            [-74.069291475, 40.68975712],
            [-74.069315512, 40.694477275],
            [-74.072705111, 40.694467352],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1417",
      },
    },
    {
      type: "Feature",
      id: "sm482826b3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069315512, 40.694477275],
            [-74.069291475, 40.68975712],
            [-74.065813986, 40.689752989],
            [-74.065838095, 40.694487455],
            [-74.069315512, 40.694477275],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1416",
      },
    },
    {
      type: "Feature",
      id: "smd1e53b4b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.065838095, 40.694487455],
            [-74.065813986, 40.689752989],
            [-74.062853141, 40.689749472],
            [-74.062877312, 40.694496122],
            [-74.065838095, 40.694487455],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1415",
      },
    },
    {
      type: "Feature",
      id: "sm77603491",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062877312, 40.694496122],
            [-74.062853141, 40.689749472],
            [-74.059335718, 40.689745294],
            [-74.059359963, 40.694506419],
            [-74.062877312, 40.694496122],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1414",
      },
    },
    {
      type: "Feature",
      id: "sm7bbd0648",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059359963, 40.694506419],
            [-74.059335718, 40.689745294],
            [-74.056075458, 40.689741421],
            [-74.056099771, 40.694515963],
            [-74.059359963, 40.694506419],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1413",
      },
    },
    {
      type: "Feature",
      id: "smca87886e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.056099771, 40.694515963],
            [-74.056075458, 40.689741421],
            [-74.052897052, 40.689737645],
            [-74.052921432, 40.694525267],
            [-74.056099771, 40.694515963],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1412",
      },
    },
    {
      type: "Feature",
      id: "smc5641600",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.052921432, 40.694525267],
            [-74.052897052, 40.689737645],
            [-74.049506222, 40.689733617],
            [-74.049530673, 40.694535193],
            [-74.052921432, 40.694525267],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1411",
      },
    },
    {
      type: "Feature",
      id: "sm37e9d67a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049530673, 40.694535193],
            [-74.049506222, 40.689733617],
            [-74.046329805, 40.689729844],
            [-74.046354322, 40.694544492],
            [-74.049530673, 40.694535193],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1410",
      },
    },
    {
      type: "Feature",
      id: "sm30a2ad9a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046354322, 40.694544492],
            [-74.046329805, 40.689729844],
            [-74.042985536, 40.689725871],
            [-74.043010123, 40.694554282],
            [-74.046354322, 40.694544492],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1409",
      },
    },
    {
      type: "Feature",
      id: "sm17c0677f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043010123, 40.694554282],
            [-74.042985536, 40.689725871],
            [-74.039725276, 40.689721998],
            [-74.039749931, 40.694563826],
            [-74.043010123, 40.694554282],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1408",
      },
    },
    {
      type: "Feature",
      id: "sm8dd76a60",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039749931, 40.694563826],
            [-74.039725276, 40.689721998],
            [-74.036465678, 40.689718126],
            [-74.036490402, 40.694573368],
            [-74.039749931, 40.694563826],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1407",
      },
    },
    {
      type: "Feature",
      id: "smd688c905",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036490402, 40.694573368],
            [-74.036465678, 40.689718126],
            [-74.033906644, 40.689715086],
            [-74.033091253, 40.690496057],
            [-74.033113077, 40.694583255],
            [-74.036490402, 40.694573368],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1406",
      },
    },
    {
      type: "Feature",
      id: "sm751c161f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036538099, 40.699286563],
            [-74.036514096, 40.694573299],
            [-74.033113077, 40.694583255],
            [-74.033134168, 40.69853301],
            [-74.033906644, 40.699281341],
            [-74.036538099, 40.699286563],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1405",
      },
    },
    {
      type: "Feature",
      id: "sm7bcc04ad",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036514096, 40.694573299],
            [-74.036538099, 40.699286563],
            [-74.039845265, 40.699293127],
            [-74.039821179, 40.694563617],
            [-74.036514096, 40.694573299],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1404",
      },
    },
    {
      type: "Feature",
      id: "smc4d631a8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039821179, 40.694563617],
            [-74.039845265, 40.699293127],
            [-74.043196175, 40.699299778],
            [-74.043172006, 40.694553808],
            [-74.039821179, 40.694563617],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1403",
      },
    },
    {
      type: "Feature",
      id: "smf514c17b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043172006, 40.694553808],
            [-74.043196175, 40.699299778],
            [-74.046367302, 40.699306072],
            [-74.046343054, 40.694544525],
            [-74.043172006, 40.694553808],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1402",
      },
    },
    {
      type: "Feature",
      id: "sm32da9e1d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046343054, 40.694544525],
            [-74.046367302, 40.699306072],
            [-74.049590128, 40.699312469],
            [-74.049565799, 40.694535091],
            [-74.046343054, 40.694544525],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1401",
      },
    },
    {
      type: "Feature",
      id: "smebfb78bf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049565799, 40.694535091],
            [-74.049590128, 40.699312469],
            [-74.052937393, 40.699319112],
            [-74.05291298, 40.694525292],
            [-74.049565799, 40.694535091],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1400",
      },
    },
    {
      type: "Feature",
      id: "sm00f35b18",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05291298, 40.694525292],
            [-74.052937393, 40.699319112],
            [-74.056158065, 40.699325504],
            [-74.056133571, 40.694515864],
            [-74.05291298, 40.694525292],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1399",
      },
    },
    {
      type: "Feature",
      id: "sm3572b810",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.056133571, 40.694515864],
            [-74.056158065, 40.699325504],
            [-74.05941983, 40.699331978],
            [-74.059395255, 40.694506316],
            [-74.056133571, 40.694515864],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1398",
      },
    },
    {
      type: "Feature",
      id: "sma1dc36d6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059395255, 40.694506316],
            [-74.05941983, 40.699331978],
            [-74.06285392, 40.699338794],
            [-74.062829259, 40.694496263],
            [-74.059395255, 40.694506316],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1397",
      },
    },
    {
      type: "Feature",
      id: "sm2b81651c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062829259, 40.694496263],
            [-74.06285392, 40.699338794],
            [-74.065946176, 40.699344931],
            [-74.065921438, 40.694487211],
            [-74.062829259, 40.694496263],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1396",
      },
    },
    {
      type: "Feature",
      id: "sm4a580a9d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.065921438, 40.694487211],
            [-74.065946176, 40.699344931],
            [-74.069380267, 40.699351747],
            [-74.069355443, 40.694477158],
            [-74.065921438, 40.694487211],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1395",
      },
    },
    {
      type: "Feature",
      id: "sm5c19493e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069355443, 40.694477158],
            [-74.069380267, 40.699351747],
            [-74.072641866, 40.69935822],
            [-74.07261696, 40.69446761],
            [-74.069355443, 40.694477158],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1394",
      },
    },
    {
      type: "Feature",
      id: "sm9a5eb679",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07261696, 40.69446761],
            [-74.072641866, 40.69935822],
            [-74.0748908, 40.699362684],
            [-74.075834937, 40.698777035],
            [-74.075812943, 40.694458254],
            [-74.07261696, 40.69446761],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1393",
      },
    },
    {
      type: "Feature",
      id: "sme5792f99",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072786707, 40.678383322],
            [-74.072737286, 40.683293059],
            [-74.075813248, 40.683310865],
            [-74.075856393, 40.679024637],
            [-74.075856393, 40.679024637],
            [-74.074976628, 40.678373717],
            [-74.072786707, 40.678383322],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1444",
      },
    },
    {
      type: "Feature",
      id: "sm934a658b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072737286, 40.683293059],
            [-74.072786707, 40.678383322],
            [-74.069353327, 40.678398381],
            [-74.069304259, 40.683273187],
            [-74.072737286, 40.683293059],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1443",
      },
    },
    {
      type: "Feature",
      id: "smf4d776b8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069304259, 40.683273187],
            [-74.069353327, 40.678398381],
            [-74.066004145, 40.67841307],
            [-74.065955419, 40.683253802],
            [-74.069304259, 40.683273187],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1442",
      },
    },
    {
      type: "Feature",
      id: "smbcae6e71",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.065955419, 40.683253802],
            [-74.066004145, 40.67841307],
            [-74.062829907, 40.678426992],
            [-74.062781507, 40.68323543],
            [-74.065955419, 40.683253802],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1441",
      },
    },
    {
      type: "Feature",
      id: "sm0531b930",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062781507, 40.68323543],
            [-74.062829907, 40.678426992],
            [-74.059484328, 40.678441666],
            [-74.05943627, 40.683216066],
            [-74.062781507, 40.68323543],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1440",
      },
    },
    {
      type: "Feature",
      id: "smd58c97e4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05943627, 40.683216066],
            [-74.059484328, 40.678441666],
            [-74.05617839, 40.678456166],
            [-74.056130671, 40.683196931],
            [-74.05943627, 40.683216066],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1439",
      },
    },
    {
      type: "Feature",
      id: "sm0fbf1749",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.056130671, 40.683196931],
            [-74.05617839, 40.678456166],
            [-74.052998583, 40.678470113],
            [-74.05295119, 40.683178526],
            [-74.056130671, 40.683196931],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1438",
      },
    },
    {
      type: "Feature",
      id: "sm2e70f980",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05295119, 40.683178526],
            [-74.052998583, 40.678470113],
            [-74.049521959, 40.678485362],
            [-74.049474922, 40.683158403],
            [-74.05295119, 40.683178526],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1437",
      },
    },
    {
      type: "Feature",
      id: "smbb527243",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049474922, 40.683158403],
            [-74.049521959, 40.678485362],
            [-74.046170811, 40.67850006],
            [-74.046124117, 40.683139006],
            [-74.049474922, 40.683158403],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1436",
      },
    },
    {
      type: "Feature",
      id: "sm4de92923",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046124117, 40.683139006],
            [-74.046170811, 40.67850006],
            [-74.043033594, 40.67851382],
            [-74.042987221, 40.683120848],
            [-74.046124117, 40.683139006],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1435",
      },
    },
    {
      type: "Feature",
      id: "smb2b4f866",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.042987221, 40.683120848],
            [-74.043033594, 40.67851382],
            [-74.039724708, 40.678528333],
            [-74.039678673, 40.683101696],
            [-74.042987221, 40.683120848],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1434",
      },
    },
    {
      type: "Feature",
      id: "sm9ca46711",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039678673, 40.683101696],
            [-74.039724708, 40.678528333],
            [-74.036377818, 40.678543013],
            [-74.036332126, 40.683082324],
            [-74.039678673, 40.683101696],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1433",
      },
    },
    {
      type: "Feature",
      id: "sm4e805537",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036332126, 40.683082324],
            [-74.036377818, 40.678543013],
            [-74.034164137, 40.678552722],
            [-74.033262915, 40.679268731],
            [-74.033262915, 40.683064557],
            [-74.036332126, 40.683082324],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1432",
      },
    },
    {
      type: "Feature",
      id: "sm5ad8608d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036235134, 40.687998533],
            [-74.036284627, 40.683082049],
            [-74.033262915, 40.683064557],
            [-74.033262915, 40.687176872],
            [-74.033949561, 40.687990414],
            [-74.036235134, 40.687998533],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1431",
      },
    },
    {
      type: "Feature",
      id: "sm50de82a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036284627, 40.683082049],
            [-74.036235134, 40.687998533],
            [-74.039710826, 40.68801088],
            [-74.039760239, 40.683102168],
            [-74.036284627, 40.683082049],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1430",
      },
    },
    {
      type: "Feature",
      id: "smc3f2ba96",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039760239, 40.683102168],
            [-74.039710826, 40.68801088],
            [-74.043099706, 40.688022919],
            [-74.043149044, 40.683121784],
            [-74.039760239, 40.683102168],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1429",
      },
    },
    {
      type: "Feature",
      id: "sm439889a4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043149044, 40.683121784],
            [-74.043099706, 40.688022919],
            [-74.046228156, 40.688034033],
            [-74.046277423, 40.683139893],
            [-74.043149044, 40.683121784],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1428",
      },
    },
    {
      type: "Feature",
      id: "smb1fcfd72",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046277423, 40.683139893],
            [-74.046228156, 40.688034033],
            [-74.04957314, 40.688045916],
            [-74.049622332, 40.683159255],
            [-74.046277423, 40.683139893],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1427",
      },
    },
    {
      type: "Feature",
      id: "smb430ecb1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049622332, 40.683159255],
            [-74.04957314, 40.688045916],
            [-74.052915831, 40.688057791],
            [-74.052964948, 40.683178604],
            [-74.049622332, 40.683159255],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1426",
      },
    },
    {
      type: "Feature",
      id: "sm60d204c0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.052964948, 40.683178604],
            [-74.052915831, 40.688057791],
            [-74.056047884, 40.688068918],
            [-74.05609693, 40.683196734],
            [-74.052964948, 40.683178604],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1425",
      },
    },
    {
      type: "Feature",
      id: "sm333321eb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05609693, 40.683196734],
            [-74.056047884, 40.688068918],
            [-74.059439058, 40.688080965],
            [-74.059488027, 40.683216364],
            [-74.05609693, 40.683196734],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1424",
      },
    },
    {
      type: "Feature",
      id: "smd76436df",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059488027, 40.683216364],
            [-74.059439058, 40.688080965],
            [-74.062911146, 40.688093299],
            [-74.062960037, 40.683236462],
            [-74.059488027, 40.683216364],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1423",
      },
    },
    {
      type: "Feature",
      id: "sm60af6f19",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062960037, 40.683236462],
            [-74.062911146, 40.688093299],
            [-74.065916095, 40.688103974],
            [-74.065964919, 40.683253856],
            [-74.062960037, 40.683236462],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1422",
      },
    },
    {
      type: "Feature",
      id: "sma57ed062",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.065964919, 40.683253856],
            [-74.065916095, 40.688103974],
            [-74.069307596, 40.688116022],
            [-74.069356344, 40.683273488],
            [-74.065964919, 40.683253856],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1421",
      },
    },
    {
      type: "Feature",
      id: "sm4d380ea4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069356344, 40.683273488],
            [-74.069307596, 40.688116022],
            [-74.07261589, 40.688127775],
            [-74.072664563, 40.683292638],
            [-74.069356344, 40.683273488],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1420",
      },
    },
    {
      type: "Feature",
      id: "sm857ebba4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072664563, 40.683292638],
            [-74.07261589, 40.688127775],
            [-74.075169749, 40.688136848],
            [-74.075770564, 40.687551101],
            [-74.075813248, 40.683310865],
            [-74.072664563, 40.683292638],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1419",
      },
    },
    {
      type: "Feature",
      id: "sm1168038e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072677659, 40.666896692],
            [-74.072652608, 40.671894038],
            [-74.075869377, 40.671903315],
            [-74.075942223, 40.667648896],
            [-74.075942223, 40.667648896],
            [-74.074869339, 40.66690021],
            [-74.072677659, 40.666896692],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1470",
      },
    },
    {
      type: "Feature",
      id: "sm565f8388",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072652608, 40.671894038],
            [-74.072677659, 40.666896692],
            [-74.069376305, 40.666891392],
            [-74.069351274, 40.671884518],
            [-74.072652608, 40.671894038],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1469",
      },
    },
    {
      type: "Feature",
      id: "sm0ef4153c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069351274, 40.671884518],
            [-74.069376305, 40.666891392],
            [-74.066202063, 40.666886297],
            [-74.066177053, 40.671875364],
            [-74.069351274, 40.671884518],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1468",
      },
    },
    {
      type: "Feature",
      id: "smf69b0cef",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.066177053, 40.671875364],
            [-74.066202063, 40.666886297],
            [-74.063068289, 40.666881266],
            [-74.0630433, 40.671866327],
            [-74.066177053, 40.671875364],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1467",
      },
    },
    {
      type: "Feature",
      id: "sm8bf7ad00",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0630433, 40.671866327],
            [-74.063068289, 40.666881266],
            [-74.0598916, 40.666876167],
            [-74.059866631, 40.671857166],
            [-74.0630433, 40.671866327],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1466",
      },
    },
    {
      type: "Feature",
      id: "smec5283f2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059866631, 40.671857166],
            [-74.0598916, 40.666876167],
            [-74.056587798, 40.666870863],
            [-74.05656285, 40.671847639],
            [-74.059866631, 40.671857166],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1465",
      },
    },
    {
      type: "Feature",
      id: "sm05df6dbe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05656285, 40.671847639],
            [-74.056587798, 40.666870863],
            [-74.053368357, 40.666865695],
            [-74.05334343, 40.671838355],
            [-74.05656285, 40.671847639],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1464",
      },
    },
    {
      type: "Feature",
      id: "sm714e65e5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05334343, 40.671838355],
            [-74.053368357, 40.666865695],
            [-74.050280598, 40.666860738],
            [-74.050255691, 40.671829451],
            [-74.05334343, 40.671838355],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1463",
      },
    },
    {
      type: "Feature",
      id: "smfccd1530",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.050255691, 40.671829451],
            [-74.050280598, 40.666860738],
            [-74.046888355, 40.666855292],
            [-74.04686347, 40.671819669],
            [-74.050255691, 40.671829451],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1462",
      },
    },
    {
      type: "Feature",
      id: "smb4f0ff2d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.04686347, 40.671819669],
            [-74.046888355, 40.666855292],
            [-74.043841717, 40.666850401],
            [-74.043816851, 40.671810883],
            [-74.04686347, 40.671819669],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1461",
      },
    },
    {
      type: "Feature",
      id: "sm6176e921",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043816851, 40.671810883],
            [-74.043841717, 40.666850401],
            [-74.040705495, 40.666845366],
            [-74.040680649, 40.671801839],
            [-74.043816851, 40.671810883],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1460",
      },
    },
    {
      type: "Feature",
      id: "smf3052409",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040680649, 40.671801839],
            [-74.040705495, 40.666845366],
            [-74.037525869, 40.666840262],
            [-74.037501044, 40.67179267],
            [-74.040680649, 40.671801839],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1459",
      },
    },
    {
      type: "Feature",
      id: "sma0c024db",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037501044, 40.67179267],
            [-74.037525869, 40.666840262],
            [-74.03431434, 40.666835106],
            [-74.033284371, 40.667453587],
            [-74.033262681, 40.671780448],
            [-74.037501044, 40.67179267],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1458",
      },
    },
    {
      type: "Feature",
      id: "smed3171aa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037361565, 40.676862883],
            [-74.037386985, 40.671792341],
            [-74.033262681, 40.671780448],
            [-74.033241457, 40.676014079],
            [-74.034099764, 40.676860304],
            [-74.037361565, 40.676862883],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1457",
      },
    },
    {
      type: "Feature",
      id: "smeab38fb1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037386985, 40.671792341],
            [-74.037361565, 40.676862883],
            [-74.04075219, 40.676865564],
            [-74.040777574, 40.671802119],
            [-74.037386985, 40.671792341],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1456",
      },
    },
    {
      type: "Feature",
      id: "sm5c15be18",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040777574, 40.671802119],
            [-74.04075219, 40.676865564],
            [-74.043968707, 40.676868108],
            [-74.043994057, 40.671811395],
            [-74.040777574, 40.671802119],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1455",
      },
    },
    {
      type: "Feature",
      id: "sm024fed90",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043994057, 40.671811395],
            [-74.043968707, 40.676868108],
            [-74.047014216, 40.676870516],
            [-74.047039534, 40.671820177],
            [-74.043994057, 40.671811395],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1454",
      },
    },
    {
      type: "Feature",
      id: "sm3608a09a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047039534, 40.671820177],
            [-74.047014216, 40.676870516],
            [-74.05036421, 40.676873165],
            [-74.050389493, 40.671829837],
            [-74.047039534, 40.671820177],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1453",
      },
    },
    {
      type: "Feature",
      id: "sm271b0ca8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.050389493, 40.671829837],
            [-74.05036421, 40.676873165],
            [-74.053454266, 40.676875609],
            [-74.053479517, 40.671838748],
            [-74.050389493, 40.671829837],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1452",
      },
    },
    {
      type: "Feature",
      id: "smf67db54a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053479517, 40.671838748],
            [-74.053454266, 40.676875609],
            [-74.056627867, 40.676878119],
            [-74.056653085, 40.6718479],
            [-74.053479517, 40.671838748],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1451",
      },
    },
    {
      type: "Feature",
      id: "sm8bacadad",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.056653085, 40.6718479],
            [-74.056627867, 40.676878119],
            [-74.059932825, 40.676880733],
            [-74.059958008, 40.671857431],
            [-74.056653085, 40.6718479],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1450",
      },
    },
    {
      type: "Feature",
      id: "smbdc07dd0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059958008, 40.671857431],
            [-74.059932825, 40.676880733],
            [-74.063067754, 40.676883212],
            [-74.063092904, 40.671866471],
            [-74.059958008, 40.671857431],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1449",
      },
    },
    {
      type: "Feature",
      id: "smf00ea614",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.063092904, 40.671866471],
            [-74.063067754, 40.676883212],
            [-74.066071653, 40.676885588],
            [-74.066096772, 40.671875133],
            [-74.063092904, 40.671866471],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1448",
      },
    },
    {
      type: "Feature",
      id: "sme85101af",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.066096772, 40.671875133],
            [-74.066071653, 40.676885588],
            [-74.069418547, 40.676888235],
            [-74.069443631, 40.671884785],
            [-74.066096772, 40.671875133],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1447",
      },
    },
    {
      type: "Feature",
      id: "sm95a8db4f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069443631, 40.671884785],
            [-74.069418547, 40.676888235],
            [-74.072639144, 40.676890782],
            [-74.072664193, 40.671894072],
            [-74.069443631, 40.671884785],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1446",
      },
    },
    {
      type: "Feature",
      id: "sm3314cc33",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072664193, 40.671894072],
            [-74.072639144, 40.676890782],
            [-74.075255578, 40.676892851],
            [-74.07579202, 40.676420919],
            [-74.075869377, 40.671903315],
            [-74.072664193, 40.671894072],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1445",
      },
    },
    {
      type: "Feature",
      id: "smbbec1a0e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019489022, 40.669688994],
            [-74.025358083, 40.669707857],
            [-74.025373587, 40.666932535],
            [-74.020238106, 40.666900208],
            [-74.019508545, 40.667681446],
            [-74.019489022, 40.669688994],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1483",
      },
    },
    {
      type: "Feature",
      id: "sm0585fa88",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025206806, 40.696781035],
            [-74.019225687, 40.69676182],
            [-74.019208138, 40.698565548],
            [-74.020066445, 40.69937895],
            [-74.025192194, 40.699395416],
            [-74.025206806, 40.696781035],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1494",
      },
    },
    {
      type: "Feature",
      id: "sm58fe7328",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019225687, 40.69676182],
            [-74.025206806, 40.696781035],
            [-74.025222273, 40.694013576],
            [-74.01925261, 40.693994397],
            [-74.019225687, 40.69676182],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1493",
      },
    },
    {
      type: "Feature",
      id: "sm588eadde",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01925261, 40.693994397],
            [-74.025222273, 40.694013576],
            [-74.025237371, 40.691311907],
            [-74.019278892, 40.691292763],
            [-74.01925261, 40.693994397],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1492",
      },
    },
    {
      type: "Feature",
      id: "sm9805856d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019278892, 40.691292763],
            [-74.025237371, 40.691311907],
            [-74.025252642, 40.688579243],
            [-74.019305474, 40.688560135],
            [-74.019278892, 40.691292763],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1491",
      },
    },
    {
      type: "Feature",
      id: "sm7ff2f0a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019305474, 40.688560135],
            [-74.025252642, 40.688579243],
            [-74.025266748, 40.686054867],
            [-74.019330167, 40.686021662],
            [-74.019305474, 40.688560135],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1490",
      },
    },
    {
      type: "Feature",
      id: "smd6f87859",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019330167, 40.686021662],
            [-74.025266748, 40.686054867],
            [-74.025283008, 40.68314502],
            [-74.019358334, 40.683125982],
            [-74.019330167, 40.686021662],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1489",
      },
    },
    {
      type: "Feature",
      id: "smded5f9c2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019358334, 40.683125982],
            [-74.025283008, 40.68314502],
            [-74.025297742, 40.680508138],
            [-74.019383982, 40.680489134],
            [-74.019358334, 40.683125982],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1488",
      },
    },
    {
      type: "Feature",
      id: "sm0483dfea",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019383982, 40.680489134],
            [-74.025297742, 40.680508138],
            [-74.0253132, 40.677741519],
            [-74.019410891, 40.677722552],
            [-74.019383982, 40.680489134],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1487",
      },
    },
    {
      type: "Feature",
      id: "smd6ca0fef",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019410891, 40.677722552],
            [-74.0253132, 40.677741519],
            [-74.025327932, 40.675104699],
            [-74.019436536, 40.675085766],
            [-74.019410891, 40.677722552],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1486",
      },
    },
    {
      type: "Feature",
      id: "sm70284b3e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019436536, 40.675085766],
            [-74.025327932, 40.675104699],
            [-74.025343011, 40.672405712],
            [-74.019462785, 40.672386814],
            [-74.019436536, 40.675085766],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1485",
      },
    },
    {
      type: "Feature",
      id: "smcec4b2be",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019462785, 40.672386814],
            [-74.025343011, 40.672405712],
            [-74.025358083, 40.669707857],
            [-74.019489022, 40.669688994],
            [-74.019462785, 40.672386814],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1484",
      },
    },
    {
      type: "Feature",
      id: "smae3eb4b6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031305171, 40.696792218],
            [-74.025206853, 40.696772626],
            [-74.025192194, 40.699395416],
            [-74.030194466, 40.699411486],
            [-74.031310265, 40.69863062],
            [-74.031305171, 40.696792218],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1471",
      },
    },
    {
      type: "Feature",
      id: "sm783bf3d0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025358355, 40.66965917],
            [-74.031230054, 40.669678041],
            [-74.031224434, 40.667648894],
            [-74.031224434, 40.667648894],
            [-74.030580703, 40.666965312],
            [-74.025373587, 40.666932535],
            [-74.025358355, 40.66965917],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1482",
      },
    },
    {
      type: "Feature",
      id: "sma1409fae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031230054, 40.669678041],
            [-74.025358355, 40.66965917],
            [-74.025342891, 40.672427227],
            [-74.031237722, 40.672446172],
            [-74.031230054, 40.669678041],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1481",
      },
    },
    {
      type: "Feature",
      id: "smdb6b395e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031237722, 40.672446172],
            [-74.025342891, 40.672427227],
            [-74.025327624, 40.675159864],
            [-74.031245292, 40.675178881],
            [-74.031237722, 40.672446172],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1480",
      },
    },
    {
      type: "Feature",
      id: "sm326d6860",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031245292, 40.675178881],
            [-74.025327624, 40.675159864],
            [-74.025313184, 40.677744284],
            [-74.031252372, 40.677734821],
            [-74.031245292, 40.675178881],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1479",
      },
    },
    {
      type: "Feature",
      id: "sm628f6372",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031252372, 40.677734821],
            [-74.025313184, 40.677744284],
            [-74.025297599, 40.680533649],
            [-74.031260179, 40.680552809],
            [-74.031252372, 40.677734821],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1478",
      },
    },
    {
      type: "Feature",
      id: "smb12fdbd3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031260179, 40.680552809],
            [-74.025297599, 40.680533649],
            [-74.02528251, 40.6832341],
            [-74.03126766, 40.683253332],
            [-74.031260179, 40.680552809],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1477",
      },
    },
    {
      type: "Feature",
      id: "sm795f9d7d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03126766, 40.683253332],
            [-74.02528251, 40.6832341],
            [-74.025266713, 40.686061161],
            [-74.031275492, 40.686080468],
            [-74.03126766, 40.683253332],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1476",
      },
    },
    {
      type: "Feature",
      id: "sme9d39727",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031275492, 40.686080468],
            [-74.025266713, 40.686061161],
            [-74.025252624, 40.688582429],
            [-74.031282397, 40.688572823],
            [-74.031275492, 40.686080468],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1475",
      },
    },
    {
      type: "Feature",
      id: "sm2194f87f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031282397, 40.688572823],
            [-74.025252624, 40.688582429],
            [-74.025237404, 40.69130598],
            [-74.031290024, 40.691325426],
            [-74.031282397, 40.688572823],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1474",
      },
    },
    {
      type: "Feature",
      id: "smbb853f92",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031290024, 40.691325426],
            [-74.025237404, 40.69130598],
            [-74.025222107, 40.694043219],
            [-74.031297608, 40.694062738],
            [-74.031290024, 40.691325426],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1473",
      },
    },
    {
      type: "Feature",
      id: "sm88bd2bb4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031297608, 40.694062738],
            [-74.025222107, 40.694043219],
            [-74.025206853, 40.696772626],
            [-74.031305171, 40.696792218],
            [-74.031297608, 40.694062738],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1472",
      },
    },
    {
      type: "Feature",
      id: "sm1a6c9187",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005878888, 40.669749055],
            [-74.011519065, 40.669722648],
            [-74.0114961, 40.666900834],
            [-74.006655398, 40.666932762],
            [-74.005882921, 40.667811653],
            [-74.005878888, 40.669749055],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1507",
      },
    },
    {
      type: "Feature",
      id: "smdc81317b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011739506, 40.696803456],
            [-74.0058225, 40.696831148],
            [-74.005818549, 40.698728229],
            [-74.006312075, 40.699362682],
            [-74.011760136, 40.699337186],
            [-74.011739506, 40.696803456],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1518",
      },
    },
    {
      type: "Feature",
      id: "smc4d6d3e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0058225, 40.696831148],
            [-74.011739506, 40.696803456],
            [-74.011716998, 40.69403885],
            [-74.005828258, 40.694066411],
            [-74.0058225, 40.696831148],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1517",
      },
    },
    {
      type: "Feature",
      id: "sm39dbb28e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005828258, 40.694066411],
            [-74.011716998, 40.69403885],
            [-74.011693944, 40.691207043],
            [-74.005834155, 40.69123447],
            [-74.005828258, 40.694066411],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1516",
      },
    },
    {
      type: "Feature",
      id: "sm1e956352",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005834155, 40.69123447],
            [-74.011693944, 40.691207043],
            [-74.011672994, 40.688633628],
            [-74.005839514, 40.688660933],
            [-74.005834155, 40.69123447],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1515",
      },
    },
    {
      type: "Feature",
      id: "sm207eac0e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005839514, 40.688660933],
            [-74.011672994, 40.688633628],
            [-74.011651371, 40.685977463],
            [-74.005845116, 40.685970512],
            [-74.005839514, 40.688660933],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1514",
      },
    },
    {
      type: "Feature",
      id: "sm09949808",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005845116, 40.685970512],
            [-74.011651371, 40.685977463],
            [-74.011629134, 40.683245665],
            [-74.005850804, 40.683238747],
            [-74.005845116, 40.685970512],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1513",
      },
    },
    {
      type: "Feature",
      id: "sm209d404e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005850804, 40.683238747],
            [-74.011629134, 40.683245665],
            [-74.011606516, 40.680467017],
            [-74.005856519, 40.680493934],
            [-74.005850804, 40.683238747],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1512",
      },
    },
    {
      type: "Feature",
      id: "smd6feb001",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005856519, 40.680493934],
            [-74.011606516, 40.680467017],
            [-74.011583211, 40.677603896],
            [-74.00586248, 40.677630677],
            [-74.005856519, 40.680493934],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1511",
      },
    },
    {
      type: "Feature",
      id: "smffaae814",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00586248, 40.677630677],
            [-74.011583211, 40.677603896],
            [-74.011563072, 40.675129604],
            [-74.005867631, 40.675156268],
            [-74.00586248, 40.677630677],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1510",
      },
    },
    {
      type: "Feature",
      id: "sma269eb6e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005867631, 40.675156268],
            [-74.011563072, 40.675129604],
            [-74.011540555, 40.672363095],
            [-74.005873391, 40.672389627],
            [-74.005867631, 40.675156268],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1509",
      },
    },
    {
      type: "Feature",
      id: "smd548c8c1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005873391, 40.672389627],
            [-74.011540555, 40.672363095],
            [-74.011519065, 40.669722648],
            [-74.005878888, 40.669749055],
            [-74.005873391, 40.672389627],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1508",
      },
    },
    {
      type: "Feature",
      id: "smc3749f7c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017439998, 40.696819959],
            [-74.011739858, 40.696846636],
            [-74.011760136, 40.699337186],
            [-74.016740504, 40.699313878],
            [-74.01742715, 40.698679424],
            [-74.017439998, 40.696819959],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1495",
      },
    },
    {
      type: "Feature",
      id: "sm61773192",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011518703, 40.669678245],
            [-74.017627684, 40.669649643],
            [-74.017641726, 40.667616345],
            [-74.017641726, 40.667616345],
            [-74.016525927, 40.666867658],
            [-74.0114961, 40.666900834],
            [-74.011518703, 40.669678245],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1506",
      },
    },
    {
      type: "Feature",
      id: "smbbdb667b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017627684, 40.669649643],
            [-74.011518703, 40.669678245],
            [-74.011540659, 40.672375954],
            [-74.017609051, 40.672347542],
            [-74.017627684, 40.669649643],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1505",
      },
    },
    {
      type: "Feature",
      id: "sm2ce7039b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017609051, 40.672347542],
            [-74.011540659, 40.672375954],
            [-74.011564002, 40.67524392],
            [-74.017589241, 40.675215712],
            [-74.017609051, 40.672347542],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1504",
      },
    },
    {
      type: "Feature",
      id: "sm3c6beff9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017589241, 40.675215712],
            [-74.011564002, 40.67524392],
            [-74.01158462, 40.67777707],
            [-74.017571743, 40.677749042],
            [-74.017589241, 40.675215712],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1503",
      },
    },
    {
      type: "Feature",
      id: "sm4c7348c8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017571743, 40.677749042],
            [-74.01158462, 40.67777707],
            [-74.011606648, 40.68048329],
            [-74.017553049, 40.680455453],
            [-74.017571743, 40.677749042],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1502",
      },
    },
    {
      type: "Feature",
      id: "sm99d3456e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017553049, 40.680455453],
            [-74.011606648, 40.68048329],
            [-74.011629181, 40.683251472],
            [-74.017533926, 40.683223831],
            [-74.017553049, 40.680455453],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1501",
      },
    },
    {
      type: "Feature",
      id: "sme0b327e4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017533926, 40.683223831],
            [-74.011629181, 40.683251472],
            [-74.011652152, 40.686073371],
            [-74.017514431, 40.686045931],
            [-74.017533926, 40.683223831],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1500",
      },
    },
    {
      type: "Feature",
      id: "smc0785b75",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017514431, 40.686045931],
            [-74.011652152, 40.686073371],
            [-74.011672811, 40.688611131],
            [-74.017496899, 40.688583871],
            [-74.017514431, 40.686045931],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1499",
      },
    },
    {
      type: "Feature",
      id: "smb89dae9f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017496899, 40.688583871],
            [-74.011672811, 40.688611131],
            [-74.011694544, 40.691280757],
            [-74.017478455, 40.691253686],
            [-74.017496899, 40.688583871],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1498",
      },
    },
    {
      type: "Feature",
      id: "smcd0af6d4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017478455, 40.691253686],
            [-74.011694544, 40.691280757],
            [-74.011717592, 40.694111757],
            [-74.017458895, 40.694084886],
            [-74.017478455, 40.691253686],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1497",
      },
    },
    {
      type: "Feature",
      id: "smec1bc8c9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017458895, 40.694084886],
            [-74.011717592, 40.694111757],
            [-74.011739858, 40.696846636],
            [-74.017439998, 40.696819959],
            [-74.017458895, 40.694084886],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1496",
      },
    },
    {
      type: "Feature",
      id: "sm5eb47182",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991917732, 40.669536856],
            [-73.99777193, 40.669536856],
            [-73.99777193, 40.666867731],
            [-73.993072694, 40.666883933],
            [-73.991913979, 40.667730274],
            [-73.991917732, 40.669536856],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1531",
      },
    },
    {
      type: "Feature",
      id: "smef4022d1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99777193, 40.696743496],
            [-73.991974259, 40.696743496],
            [-73.99197835, 40.698711961],
            [-73.992750826, 40.699313879],
            [-73.99777193, 40.699313879],
            [-73.99777193, 40.696743496],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1542",
      },
    },
    {
      type: "Feature",
      id: "sm540965ce",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991974259, 40.696743496],
            [-73.99777193, 40.696743496],
            [-73.99777193, 40.693977778],
            [-73.991968512, 40.693977778],
            [-73.991974259, 40.696743496],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1541",
      },
    },
    {
      type: "Feature",
      id: "smd888de1a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991968512, 40.693977778],
            [-73.99777193, 40.693977778],
            [-73.99777193, 40.691244485],
            [-73.991962832, 40.691244485],
            [-73.991968512, 40.693977778],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1540",
      },
    },
    {
      type: "Feature",
      id: "sme21fb802",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991962832, 40.691244485],
            [-73.99777193, 40.691244485],
            [-73.99777193, 40.688673785],
            [-73.99195749, 40.688673785],
            [-73.991962832, 40.691244485],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1539",
      },
    },
    {
      type: "Feature",
      id: "sma081ebe2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99195749, 40.688673785],
            [-73.99777193, 40.688673785],
            [-73.99777193, 40.685968356],
            [-73.991951883, 40.68597531],
            [-73.99195749, 40.688673785],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1538",
      },
    },
    {
      type: "Feature",
      id: "smf0995180",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991951883, 40.68597531],
            [-73.99777193, 40.685968356],
            [-73.99777193, 40.683174108],
            [-73.991946063, 40.683174108],
            [-73.991951883, 40.68597531],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1537",
      },
    },
    {
      type: "Feature",
      id: "sm0c965253",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991946063, 40.683174108],
            [-73.99777193, 40.683174108],
            [-73.99777193, 40.680342736],
            [-73.99194018, 40.680342736],
            [-73.991946063, 40.683174108],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1536",
      },
    },
    {
      type: "Feature",
      id: "smc5d46bad",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99194018, 40.680342736],
            [-73.99777193, 40.680342736],
            [-73.99777193, 40.677869256],
            [-73.991935041, 40.677869256],
            [-73.99194018, 40.680342736],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1535",
      },
    },
    {
      type: "Feature",
      id: "sme816b96b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991935041, 40.677869256],
            [-73.99777193, 40.677869256],
            [-73.99777193, 40.675102754],
            [-73.991929294, 40.675102754],
            [-73.991935041, 40.677869256],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1534",
      },
    },
    {
      type: "Feature",
      id: "smc3f10c56",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991929294, 40.675102754],
            [-73.99777193, 40.675102754],
            [-73.99777193, 40.672401236],
            [-73.991923682, 40.672401236],
            [-73.991929294, 40.675102754],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1533",
      },
    },
    {
      type: "Feature",
      id: "smdec50ed8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991923682, 40.672401236],
            [-73.99777193, 40.672401236],
            [-73.99777193, 40.669536856],
            [-73.991917732, 40.669536856],
            [-73.991923682, 40.672401236],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1532",
      },
    },
    {
      type: "Feature",
      id: "sm5f577890",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003710385, 40.696776034],
            [-73.99777193, 40.696776034],
            [-73.99777193, 40.699313879],
            [-74.003050508, 40.699313879],
            [-74.003715696, 40.698695693],
            [-74.003710385, 40.696776034],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1519",
      },
    },
    {
      type: "Feature",
      id: "sm593a0831",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99777193, 40.669634507],
            [-74.003635314, 40.669634507],
            [-74.003629868, 40.667665171],
            [-74.003629868, 40.667665171],
            [-74.002514069, 40.666851381],
            [-73.99777193, 40.666867731],
            [-73.99777193, 40.669634507],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1530",
      },
    },
    {
      type: "Feature",
      id: "sm58d6b774",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003635314, 40.669634507],
            [-73.99777193, 40.669634507],
            [-73.99777193, 40.672401236],
            [-74.003642966, 40.672401236],
            [-74.003635314, 40.669634507],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1529",
      },
    },
    {
      type: "Feature",
      id: "smba0146e7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003642966, 40.672401236],
            [-73.99777193, 40.672401236],
            [-73.99777193, 40.675070206],
            [-74.003650347, 40.675070206],
            [-74.003642966, 40.672401236],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1528",
      },
    },
    {
      type: "Feature",
      id: "smf6b0f0b3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003650347, 40.675070206],
            [-73.99777193, 40.675070206],
            [-73.99777193, 40.677836709],
            [-74.003657998, 40.677836709],
            [-74.003650347, 40.675070206],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1527",
      },
    },
    {
      type: "Feature",
      id: "sm2aa35ccd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003657998, 40.677836709],
            [-73.99777193, 40.677836709],
            [-73.99777193, 40.680407827],
            [-74.003665109, 40.680407827],
            [-74.003657998, 40.677836709],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1526",
      },
    },
    {
      type: "Feature",
      id: "sme32a9e7d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003665109, 40.680407827],
            [-73.99777193, 40.680407827],
            [-73.99777193, 40.683239196],
            [-74.00367294, 40.683239196],
            [-74.003665109, 40.680407827],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1525",
      },
    },
    {
      type: "Feature",
      id: "sm0f46817b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00367294, 40.683239196],
            [-73.99777193, 40.683239196],
            [-73.99777193, 40.685972817],
            [-74.003680501, 40.685972817],
            [-74.00367294, 40.683239196],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1524",
      },
    },
    {
      type: "Feature",
      id: "sm4e40c958",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003680501, 40.685972817],
            [-73.99777193, 40.685972817],
            [-73.99777193, 40.68880395],
            [-74.003688332, 40.68880395],
            [-74.003680501, 40.685972817],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1523",
      },
    },
    {
      type: "Feature",
      id: "smbeab82a3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003688332, 40.68880395],
            [-73.99777193, 40.68880395],
            [-73.99777193, 40.691342105],
            [-74.003695353, 40.691342105],
            [-74.003688332, 40.68880395],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1522",
      },
    },
    {
      type: "Feature",
      id: "smc8e76af0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003695353, 40.691342105],
            [-73.99777193, 40.691342105],
            [-73.99777193, 40.694042856],
            [-74.003702824, 40.694042856],
            [-74.003695353, 40.691342105],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1521",
      },
    },
    {
      type: "Feature",
      id: "sm70ebd4fe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003702824, 40.694042856],
            [-73.99777193, 40.694042856],
            [-73.99777193, 40.696776034],
            [-74.003710385, 40.696776034],
            [-74.003702824, 40.694042856],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1520",
      },
    },
    {
      type: "Feature",
      id: "sm0f25ec2c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978150107, 40.669699608],
            [-73.983996103, 40.669699608],
            [-73.983996103, 40.667095658],
            [-73.978846259, 40.667079245],
            [-73.978159613, 40.667730275],
            [-73.978150107, 40.669699608],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1555",
      },
    },
    {
      type: "Feature",
      id: "sm59a93b44",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.983996103, 40.696743498],
            [-73.978019543, 40.696743498],
            [-73.978009409, 40.698842106],
            [-73.9788248, 40.699427755],
            [-73.983996103, 40.699427755],
            [-73.983996103, 40.696743498],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1566",
      },
    },
    {
      type: "Feature",
      id: "smff483950",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978019543, 40.696743498],
            [-73.983996103, 40.696743498],
            [-73.983996103, 40.694042856],
            [-73.978032583, 40.694042856],
            [-73.978019543, 40.696743498],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1565",
      },
    },
    {
      type: "Feature",
      id: "sm79bf5903",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978032583, 40.694042856],
            [-73.983996103, 40.694042856],
            [-73.983996103, 40.691309566],
            [-73.978045781, 40.691309566],
            [-73.978032583, 40.694042856],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1564",
      },
    },
    {
      type: "Feature",
      id: "sma4b116c9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978045781, 40.691309566],
            [-73.983996103, 40.691309566],
            [-73.983996103, 40.688706328],
            [-73.97805835, 40.688706328],
            [-73.978045781, 40.691309566],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1563",
      },
    },
    {
      type: "Feature",
      id: "sm46177ebf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.97805835, 40.688706328],
            [-73.983996103, 40.688706328],
            [-73.983996103, 40.685972818],
            [-73.978071548, 40.685972818],
            [-73.97805835, 40.688706328],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1562",
      },
    },
    {
      type: "Feature",
      id: "smc721d619",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978071548, 40.685972818],
            [-73.983996103, 40.685972818],
            [-73.983996103, 40.68321964],
            [-73.978084919, 40.683203229],
            [-73.978071548, 40.685972818],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1561",
      },
    },
    {
      type: "Feature",
      id: "sm925c3e57",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978084919, 40.683203229],
            [-73.983996103, 40.68321964],
            [-73.983996103, 40.680375282],
            [-73.978098572, 40.680375282],
            [-73.978084919, 40.683203229],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1560",
      },
    },
    {
      type: "Feature",
      id: "sm17d3fbe8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978098572, 40.680375282],
            [-73.983996103, 40.680375282],
            [-73.983996103, 40.677804163],
            [-73.978110984, 40.677804163],
            [-73.978098572, 40.680375282],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1559",
      },
    },
    {
      type: "Feature",
      id: "sm4e273710",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978110984, 40.677804163],
            [-73.983996103, 40.677804163],
            [-73.983996103, 40.675102754],
            [-73.978124025, 40.675102754],
            [-73.978110984, 40.677804163],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1558",
      },
    },
    {
      type: "Feature",
      id: "sm31f781f0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978124025, 40.675102754],
            [-73.983996103, 40.675102754],
            [-73.983996103, 40.672433785],
            [-73.978136909, 40.672433785],
            [-73.978124025, 40.675102754],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1557",
      },
    },
    {
      type: "Feature",
      id: "sm50eeb5b9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.978136909, 40.672433785],
            [-73.983996103, 40.672433785],
            [-73.983996103, 40.669699608],
            [-73.978150107, 40.669699608],
            [-73.978136909, 40.672433785],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1556",
      },
    },
    {
      type: "Feature",
      id: "sma3e5349c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989938425, 40.696678422],
            [-73.983996103, 40.696678422],
            [-73.983996103, 40.699427755],
            [-73.988995736, 40.699427755],
            [-73.989939874, 40.698760766],
            [-73.989938425, 40.696678422],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1543",
      },
    },
    {
      type: "Feature",
      id: "sm46e71dbc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.983996103, 40.669699608],
            [-73.989919651, 40.669699608],
            [-73.989918417, 40.667925583],
            [-73.989918417, 40.667925583],
            [-73.98906011, 40.667111797],
            [-73.983996103, 40.667095658],
            [-73.983996103, 40.669699608],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1554",
      },
    },
    {
      type: "Feature",
      id: "sme6dc8a46",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989919651, 40.669699608],
            [-73.983996103, 40.669699608],
            [-73.983996103, 40.672466334],
            [-73.989921576, 40.672466334],
            [-73.989919651, 40.669699608],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1553",
      },
    },
    {
      type: "Feature",
      id: "sm2f59e3cc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989921576, 40.672466334],
            [-73.983996103, 40.672466334],
            [-73.983996103, 40.675265493],
            [-73.989923524, 40.675265493],
            [-73.989921576, 40.672466334],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1552",
      },
    },
    {
      type: "Feature",
      id: "smd8ae7934",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989923524, 40.675265493],
            [-73.983996103, 40.675265493],
            [-73.983996103, 40.677901801],
            [-73.989925359, 40.677901801],
            [-73.989923524, 40.675265493],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1551",
      },
    },
    {
      type: "Feature",
      id: "smfb42a308",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989925359, 40.677901801],
            [-73.983996103, 40.677901801],
            [-73.983996103, 40.680538006],
            [-73.989927193, 40.680538006],
            [-73.989925359, 40.677901801],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1550",
      },
    },
    {
      type: "Feature",
      id: "smdd9c0974",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989927193, 40.680538006],
            [-73.983996103, 40.680538006],
            [-73.983996103, 40.683206651],
            [-73.98992905, 40.683206651],
            [-73.989927193, 40.680538006],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1549",
      },
    },
    {
      type: "Feature",
      id: "sm1cd5f03f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.98992905, 40.683206651],
            [-73.983996103, 40.683206651],
            [-73.983996103, 40.685972816],
            [-73.989930975, 40.685972816],
            [-73.98992905, 40.683206651],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1548",
      },
    },
    {
      type: "Feature",
      id: "sm9299c35e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989930975, 40.685972816],
            [-73.983996103, 40.685972816],
            [-73.983996103, 40.688706326],
            [-73.989932877, 40.688706326],
            [-73.989930975, 40.685972816],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1547",
      },
    },
    {
      type: "Feature",
      id: "sm1d47e4e6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989932877, 40.688706326],
            [-73.983996103, 40.688706326],
            [-73.983996103, 40.691342104],
            [-73.989934711, 40.691342104],
            [-73.989932877, 40.688706326],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1546",
      },
    },
    {
      type: "Feature",
      id: "sm2560d05d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989934711, 40.691342104],
            [-73.983996103, 40.691342104],
            [-73.983996103, 40.694075393],
            [-73.989936613, 40.694075393],
            [-73.989934711, 40.691342104],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1545",
      },
    },
    {
      type: "Feature",
      id: "smba64e631",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.989936613, 40.694075393],
            [-73.983996103, 40.694075393],
            [-73.983996103, 40.696678422],
            [-73.989938425, 40.696678422],
            [-73.989936613, 40.694075393],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1544",
      },
    },
    {
      type: "Feature",
      id: "sm0dae6e43",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127331328, 40.655607045],
            [-74.127340269, 40.660194217],
            [-74.131024069, 40.660194218],
            [-74.13102407, 40.656254936],
            [-74.13102407, 40.656254936],
            [-74.130230136, 40.655603794],
            [-74.127331328, 40.655607045],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1592",
      },
    },
    {
      type: "Feature",
      id: "sm4d427d92",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127340269, 40.660194217],
            [-74.127331328, 40.655607045],
            [-74.124025078, 40.655610754],
            [-74.124034011, 40.660194217],
            [-74.127340269, 40.660194217],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1591",
      },
    },
    {
      type: "Feature",
      id: "smc7e7f180",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.124034011, 40.660194217],
            [-74.124025078, 40.655610754],
            [-74.120592048, 40.655614605],
            [-74.120600974, 40.660194217],
            [-74.124034011, 40.660194217],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1590",
      },
    },
    {
      type: "Feature",
      id: "smdfe6905a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.120600974, 40.660194217],
            [-74.120592048, 40.655614605],
            [-74.116946346, 40.655618694],
            [-74.116955263, 40.660194216],
            [-74.120600974, 40.660194217],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1589",
      },
    },
    {
      type: "Feature",
      id: "sme052661e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.116955263, 40.660194216],
            [-74.116946346, 40.655618694],
            [-74.113513126, 40.655622545],
            [-74.113522036, 40.660194215],
            [-74.116955263, 40.660194216],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1588",
      },
    },
    {
      type: "Feature",
      id: "smfce3b935",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.113522036, 40.660194215],
            [-74.113513126, 40.655622545],
            [-74.110165673, 40.6556263],
            [-74.110174576, 40.660194215],
            [-74.113522036, 40.660194215],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1587",
      },
    },
    {
      type: "Feature",
      id: "smd6f6004d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.110174576, 40.660194215],
            [-74.110165673, 40.6556263],
            [-74.106560982, 40.655630343],
            [-74.106569877, 40.660194214],
            [-74.110174576, 40.660194215],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1586",
      },
    },
    {
      type: "Feature",
      id: "sm4379a34c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.106569877, 40.660194214],
            [-74.106560982, 40.655630343],
            [-74.1032141, 40.655634097],
            [-74.103222988, 40.660194214],
            [-74.106569877, 40.660194214],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1585",
      },
    },
    {
      type: "Feature",
      id: "sm62b6c829",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103222988, 40.660194214],
            [-74.1032141, 40.655634097],
            [-74.099566621, 40.655638188],
            [-74.099575501, 40.660194213],
            [-74.103222988, 40.660194214],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1584",
      },
    },
    {
      type: "Feature",
      id: "smdd3c2da2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.099575501, 40.660194213],
            [-74.099566621, 40.655638188],
            [-74.096133782, 40.655642038],
            [-74.096142654, 40.660194213],
            [-74.099575501, 40.660194213],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1583",
      },
    },
    {
      type: "Feature",
      id: "smf97cfe8b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.096142654, 40.660194213],
            [-74.096133782, 40.655642038],
            [-74.092786456, 40.655645793],
            [-74.09279532, 40.660194213],
            [-74.096142654, 40.660194213],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1582",
      },
    },
    {
      type: "Feature",
      id: "sm3350fe94",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.09279532, 40.660194213],
            [-74.092786456, 40.655645793],
            [-74.0892243, 40.655649788],
            [-74.089233157, 40.660194212],
            [-74.09279532, 40.660194213],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1581",
      },
    },
    {
      type: "Feature",
      id: "smdf226184",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089233157, 40.660194212],
            [-74.0892243, 40.655649788],
            [-74.086692518, 40.655652628],
            [-74.085877127, 40.656238656],
            [-74.085877126, 40.660194211],
            [-74.089233157, 40.660194212],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1580",
      },
    },
    {
      type: "Feature",
      id: "smac910227",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089181611, 40.664737378],
            [-74.089181612, 40.660194211],
            [-74.085877126, 40.660194211],
            [-74.085877126, 40.663823997],
            [-74.086649603, 40.664735482],
            [-74.089181611, 40.664737378],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1579",
      },
    },
    {
      type: "Feature",
      id: "smf7aff57b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089181612, 40.660194211],
            [-74.089181611, 40.664737378],
            [-74.092872331, 40.664740142],
            [-74.092872332, 40.660194212],
            [-74.089181612, 40.660194211],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1578",
      },
    },
    {
      type: "Feature",
      id: "sm8234803b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092872332, 40.660194212],
            [-74.092872331, 40.664740142],
            [-74.096133897, 40.664742584],
            [-74.096133898, 40.660194212],
            [-74.092872332, 40.660194212],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1577",
      },
    },
    {
      type: "Feature",
      id: "sm3719475c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.096133898, 40.660194212],
            [-74.096133897, 40.664742584],
            [-74.099738784, 40.664745284],
            [-74.099738785, 40.660194213],
            [-74.096133898, 40.660194212],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1576",
      },
    },
    {
      type: "Feature",
      id: "smd36d2fe1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.099738785, 40.660194213],
            [-74.099738784, 40.664745284],
            [-74.103300758, 40.664747951],
            [-74.103300759, 40.660194214],
            [-74.099738785, 40.660194213],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1575",
      },
    },
    {
      type: "Feature",
      id: "smd3bd3239",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103300759, 40.660194214],
            [-74.103300758, 40.664747951],
            [-74.10669107, 40.66475049],
            [-74.106691071, 40.660194214],
            [-74.103300759, 40.660194214],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1574",
      },
    },
    {
      type: "Feature",
      id: "sma6f09d20",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.106691071, 40.660194214],
            [-74.10669107, 40.66475049],
            [-74.110295959, 40.664753189],
            [-74.11029596, 40.660194215],
            [-74.106691071, 40.660194214],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1573",
      },
    },
    {
      type: "Feature",
      id: "sma11cded5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11029596, 40.660194215],
            [-74.110295959, 40.664753189],
            [-74.113686271, 40.664755728],
            [-74.113686272, 40.660194215],
            [-74.11029596, 40.660194215],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1572",
      },
    },
    {
      type: "Feature",
      id: "sm55709ad0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.113686272, 40.660194215],
            [-74.113686271, 40.664755728],
            [-74.116990752, 40.664758203],
            [-74.116990753, 40.660194215],
            [-74.113686272, 40.660194215],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1571",
      },
    },
    {
      type: "Feature",
      id: "sm0b4ddf65",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.116990753, 40.660194215],
            [-74.116990752, 40.664758203],
            [-74.120595641, 40.664760902],
            [-74.120595642, 40.660194216],
            [-74.116990753, 40.660194215],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1570",
      },
    },
    {
      type: "Feature",
      id: "sme4328060",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.120595642, 40.660194216],
            [-74.120595641, 40.664760902],
            [-74.124071784, 40.664763505],
            [-74.124071785, 40.660194217],
            [-74.120595642, 40.660194216],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1569",
      },
    },
    {
      type: "Feature",
      id: "smd31832d3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.124071785, 40.660194217],
            [-74.124071784, 40.664763505],
            [-74.127290435, 40.664765915],
            [-74.127290436, 40.660194217],
            [-74.124071785, 40.660194217],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1568",
      },
    },
    {
      type: "Feature",
      id: "sm6e52282d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127290436, 40.660194217],
            [-74.127290435, 40.664765915],
            [-74.130122846, 40.664768036],
            [-74.131024068, 40.664116976],
            [-74.131024069, 40.660194218],
            [-74.127290436, 40.660194217],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1567",
      },
    },
    {
      type: "Feature",
      id: "sm5c3a8fc0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127503184, 40.644032419],
            [-74.127517265, 40.649389758],
            [-74.131039143, 40.649415255],
            [-74.130959698, 40.64484275],
            [-74.130959698, 40.64484275],
            [-74.129972645, 40.644028682],
            [-74.127503184, 40.644032419],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1620",
      },
    },
    {
      type: "Feature",
      id: "sm7d105f92",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127517265, 40.649389758],
            [-74.127503184, 40.644032419],
            [-74.124370547, 40.644037159],
            [-74.124384556, 40.649367079],
            [-74.127517265, 40.649389758],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1619",
      },
    },
    {
      type: "Feature",
      id: "sme57e37e0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.124384556, 40.649367079],
            [-74.124370547, 40.644037159],
            [-74.121193969, 40.644041965],
            [-74.121207904, 40.649344081],
            [-74.124384556, 40.649367079],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1618",
      },
    },
    {
      type: "Feature",
      id: "smae8b9b4e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.121207904, 40.649344081],
            [-74.121193969, 40.644041965],
            [-74.118061589, 40.644046704],
            [-74.118075452, 40.649321403],
            [-74.121207904, 40.649344081],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1617",
      },
    },
    {
      type: "Feature",
      id: "sm02a02b81",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.118075452, 40.649321403],
            [-74.118061589, 40.644046704],
            [-74.114800464, 40.644051638],
            [-74.114814251, 40.649297793],
            [-74.118075452, 40.649321403],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1616",
      },
    },
    {
      type: "Feature",
      id: "sm63b5c09b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.114814251, 40.649297793],
            [-74.114800464, 40.644051638],
            [-74.111496509, 40.644056637],
            [-74.11151022, 40.649273873],
            [-74.114814251, 40.649297793],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1615",
      },
    },
    {
      type: "Feature",
      id: "smd7ab0004",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11151022, 40.649273873],
            [-74.111496509, 40.644056637],
            [-74.10840713, 40.644061311],
            [-74.10842077, 40.649251507],
            [-74.11151022, 40.649273873],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1614",
      },
    },
    {
      type: "Feature",
      id: "sm22c095ff",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10842077, 40.649251507],
            [-74.10840713, 40.644061311],
            [-74.104974087, 40.644066505],
            [-74.104987648, 40.649226653],
            [-74.10842077, 40.649251507],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1613",
      },
    },
    {
      type: "Feature",
      id: "sm4c637f73",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.104987648, 40.649226653],
            [-74.104974087, 40.644066505],
            [-74.10188428, 40.64407118],
            [-74.10189777, 40.649204283],
            [-74.104987648, 40.649226653],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1612",
      },
    },
    {
      type: "Feature",
      id: "sm66af33e7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10189777, 40.649204283],
            [-74.10188428, 40.64407118],
            [-74.098794559, 40.644075855],
            [-74.098807978, 40.649181914],
            [-74.10189777, 40.649204283],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1611",
      },
    },
    {
      type: "Feature",
      id: "smd7fc2a1e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.098807978, 40.649181914],
            [-74.098794559, 40.644075855],
            [-74.095489491, 40.644080856],
            [-74.095502835, 40.649157986],
            [-74.098807978, 40.649181914],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1610",
      },
    },
    {
      type: "Feature",
      id: "sme95b442f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.095502835, 40.649157986],
            [-74.095489491, 40.644080856],
            [-74.092356341, 40.644085596],
            [-74.092369612, 40.649135303],
            [-74.095502835, 40.649157986],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1609",
      },
    },
    {
      type: "Feature",
      id: "sm3e27a9ff",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092369612, 40.649135303],
            [-74.092356341, 40.644085596],
            [-74.088923299, 40.64409079],
            [-74.088936491, 40.649110449],
            [-74.092369612, 40.649135303],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1608",
      },
    },
    {
      type: "Feature",
      id: "smfd61f9b6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.088936491, 40.649110449],
            [-74.088923299, 40.64409079],
            [-74.086928554, 40.644093808],
            [-74.085984416, 40.644810188],
            [-74.085930609, 40.649088688],
            [-74.088936491, 40.649110449],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1607",
      },
    },
    {
      type: "Feature",
      id: "sm474c4d77",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.088963871, 40.65409074],
            [-74.089026499, 40.649111101],
            [-74.085930609, 40.649088688],
            [-74.085877128, 40.653341026],
            [-74.086628146, 40.654089865],
            [-74.088963871, 40.65409074],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1606",
      },
    },
    {
      type: "Feature",
      id: "sm77cbe07a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089026499, 40.649111101],
            [-74.088963871, 40.65409074],
            [-74.092444502, 40.654092044],
            [-74.09250683, 40.649136297],
            [-74.089026499, 40.649111101],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1605",
      },
    },
    {
      type: "Feature",
      id: "smac05e7c8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.09250683, 40.649136297],
            [-74.092444502, 40.654092044],
            [-74.095491477, 40.654093186],
            [-74.095553542, 40.649158354],
            [-74.09250683, 40.649136297],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1604",
      },
    },
    {
      type: "Feature",
      id: "smb194697a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.095553542, 40.649158354],
            [-74.095491477, 40.654093186],
            [-74.098834353, 40.654094438],
            [-74.09889613, 40.649182553],
            [-74.095553542, 40.649158354],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1603",
      },
    },
    {
      type: "Feature",
      id: "sma481091c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.09889613, 40.649182553],
            [-74.098834353, 40.654094438],
            [-74.101963473, 40.65409561],
            [-74.10202498, 40.649205205],
            [-74.09889613, 40.649182553],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1602",
      },
    },
    {
      type: "Feature",
      id: "sm524069e4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10202498, 40.649205205],
            [-74.101963473, 40.65409561],
            [-74.10504804, 40.654096765],
            [-74.10510928, 40.649227534],
            [-74.10202498, 40.649205205],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1601",
      },
    },
    {
      type: "Feature",
      id: "smad3b7b49",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10510928, 40.649227534],
            [-74.10504804, 40.654096765],
            [-74.108478385, 40.65409805],
            [-74.108539329, 40.649252366],
            [-74.10510928, 40.649227534],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1600",
      },
    },
    {
      type: "Feature",
      id: "smdf1213b7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.108539329, 40.649252366],
            [-74.108478385, 40.65409805],
            [-74.111605867, 40.654099222],
            [-74.111666541, 40.649275006],
            [-74.108539329, 40.649252366],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1599",
      },
    },
    {
      type: "Feature",
      id: "sm9874633c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.111666541, 40.649275006],
            [-74.111605867, 40.654099222],
            [-74.114871103, 40.654100445],
            [-74.114931495, 40.649298643],
            [-74.111666541, 40.649275006],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1598",
      },
    },
    {
      type: "Feature",
      id: "sm79b1f513",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.114931495, 40.649298643],
            [-74.114871103, 40.654100445],
            [-74.118005956, 40.654101619],
            [-74.118066078, 40.649321336],
            [-74.114931495, 40.649298643],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1597",
      },
    },
    {
      type: "Feature",
      id: "smae6874ac",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.118066078, 40.649321336],
            [-74.118005956, 40.654101619],
            [-74.121093799, 40.654102776],
            [-74.121153654, 40.649343689],
            [-74.118066078, 40.649321336],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1596",
      },
    },
    {
      type: "Feature",
      id: "smdf1d1daa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.121153654, 40.649343689],
            [-74.121093799, 40.654102776],
            [-74.124482457, 40.654104045],
            [-74.124542019, 40.649368219],
            [-74.121153654, 40.649343689],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1595",
      },
    },
    {
      type: "Feature",
      id: "smcc71b9da",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.124542019, 40.649368219],
            [-74.124482457, 40.654104045],
            [-74.127666367, 40.654105238],
            [-74.127725655, 40.649391267],
            [-74.124542019, 40.649368219],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1594",
      },
    },
    {
      type: "Feature",
      id: "sm3f3cb562",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127725655, 40.649391267],
            [-74.127666367, 40.654105238],
            [-74.130079933, 40.654106142],
            [-74.131109901, 40.653487537],
            [-74.131039143, 40.649415255],
            [-74.127725655, 40.649391267],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1593",
      },
    },
    {
      type: "Feature",
      id: "sm712e2867",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.122699181, 40.633165094],
            [-74.122733579, 40.637932522],
            [-74.126013759, 40.637918893],
            [-74.125979361, 40.633151464],
            [-74.122699181, 40.633165094],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1645",
      },
    },
    {
      type: "Feature",
      id: "smd6429ae1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.122733579, 40.637932522],
            [-74.122699181, 40.633165094],
            [-74.119176704, 40.633179731],
            [-74.119211102, 40.637947158],
            [-74.122733579, 40.637932522],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1644",
      },
    },
    {
      type: "Feature",
      id: "sm8e564aed",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119211102, 40.637947158],
            [-74.119176704, 40.633179731],
            [-74.116130275, 40.63319239],
            [-74.116164674, 40.637959816],
            [-74.119211102, 40.637947158],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1643",
      },
    },
    {
      type: "Feature",
      id: "sme280591e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.116164674, 40.637959816],
            [-74.116130275, 40.63319239],
            [-74.112694566, 40.633206666],
            [-74.112728964, 40.637974091],
            [-74.116164674, 40.637959816],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1642",
      },
    },
    {
      type: "Feature",
      id: "sm124586f9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.112728964, 40.637974091],
            [-74.112694566, 40.633206666],
            [-74.10934727, 40.633220575],
            [-74.109381668, 40.637987999],
            [-74.112728964, 40.637974091],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1641",
      },
    },
    {
      type: "Feature",
      id: "smcb8004f5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.109381668, 40.637987999],
            [-74.10934727, 40.633220575],
            [-74.106087681, 40.633234119],
            [-74.106122079, 40.638001542],
            [-74.109381668, 40.637987999],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1640",
      },
    },
    {
      type: "Feature",
      id: "sma8256c5a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.106122079, 40.638001542],
            [-74.106087681, 40.633234119],
            [-74.102570608, 40.633248733],
            [-74.102605006, 40.638016155],
            [-74.106122079, 40.638001542],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1639",
      },
    },
    {
      type: "Feature",
      id: "sm5cd09579",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.102605006, 40.638016155],
            [-74.102570608, 40.633248733],
            [-74.099050011, 40.633263362],
            [-74.099084409, 40.638030783],
            [-74.102605006, 40.638016155],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1638",
      },
    },
    {
      type: "Feature",
      id: "sm4382258f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.099084409, 40.638030783],
            [-74.099050011, 40.633263362],
            [-74.096002878, 40.633276024],
            [-74.096037276, 40.638043444],
            [-74.099084409, 40.638030783],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1637",
      },
    },
    {
      type: "Feature",
      id: "sm9af3c2d1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.096037276, 40.638043444],
            [-74.096002878, 40.633276024],
            [-74.092568108, 40.633290296],
            [-74.092602506, 40.638057715],
            [-74.096037276, 40.638043444],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1636",
      },
    },
    {
      type: "Feature",
      id: "sm18e9f9d3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092602506, 40.638057715],
            [-74.092568108, 40.633290296],
            [-74.089177193, 40.633304386],
            [-74.089211591, 40.638071804],
            [-74.092602506, 40.638057715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1635",
      },
    },
    {
      type: "Feature",
      id: "sm2e1fbfc3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089211591, 40.638071804],
            [-74.089177193, 40.633304386],
            [-74.086713981, 40.633314621],
            [-74.086156081, 40.63396598],
            [-74.086089073, 40.638084778],
            [-74.089211591, 40.638071804],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1634",
      },
    },
    {
      type: "Feature",
      id: "sm11c99f90",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089251419, 40.642561512],
            [-74.089219024, 40.638071774],
            [-74.086089073, 40.638084778],
            [-74.086027334, 40.641879494],
            [-74.086842726, 40.642563334],
            [-74.089251419, 40.642561512],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1633",
      },
    },
    {
      type: "Feature",
      id: "sm293f73e6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089219024, 40.638071774],
            [-74.089251419, 40.642561512],
            [-74.092642419, 40.642558947],
            [-74.092609939, 40.638057685],
            [-74.089219024, 40.638071774],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1632",
      },
    },
    {
      type: "Feature",
      id: "sm10d7512a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092609939, 40.638057685],
            [-74.092642419, 40.642558947],
            [-74.095945237, 40.642556448],
            [-74.095912677, 40.638043962],
            [-74.092609939, 40.638057685],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1631",
      },
    },
    {
      type: "Feature",
      id: "sm8c629802",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.095912677, 40.638043962],
            [-74.095945237, 40.642556448],
            [-74.099338116, 40.642553881],
            [-74.099305472, 40.638029865],
            [-74.095912677, 40.638043962],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1630",
      },
    },
    {
      type: "Feature",
      id: "smc74bd2bc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.099305472, 40.638029865],
            [-74.099338116, 40.642553881],
            [-74.1028588, 40.642551218],
            [-74.102826069, 40.638015237],
            [-74.099305472, 40.638029865],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1629",
      },
    },
    {
      type: "Feature",
      id: "sm86b1674c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.102826069, 40.638015237],
            [-74.1028588, 40.642551218],
            [-74.106163968, 40.642548718],
            [-74.106131157, 40.638001504],
            [-74.102826069, 40.638015237],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1628",
      },
    },
    {
      type: "Feature",
      id: "smf6e7daa3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.106131157, 40.638001504],
            [-74.106163968, 40.642548718],
            [-74.109554497, 40.642546153],
            [-74.109521602, 40.637987417],
            [-74.106131157, 40.638001504],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1627",
      },
    },
    {
      type: "Feature",
      id: "smefe53943",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.109521602, 40.637987417],
            [-74.109554497, 40.642546153],
            [-74.112775245, 40.642543717],
            [-74.112742271, 40.637974035],
            [-74.109521602, 40.637987417],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1626",
      },
    },
    {
      type: "Feature",
      id: "smeb438c40",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.112742271, 40.637974035],
            [-74.112775245, 40.642543717],
            [-74.116207984, 40.64254112],
            [-74.116174926, 40.637959773],
            [-74.112742271, 40.637974035],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1625",
      },
    },
    {
      type: "Feature",
      id: "sm204cbd8d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.116174926, 40.637959773],
            [-74.116207984, 40.64254112],
            [-74.119382997, 40.642538718],
            [-74.119349861, 40.637946581],
            [-74.116174926, 40.637959773],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1624",
      },
    },
    {
      type: "Feature",
      id: "smae3bff0c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.119349861, 40.637946581],
            [-74.119382997, 40.642538718],
            [-74.122817616, 40.64253612],
            [-74.122784396, 40.637932311],
            [-74.119349861, 40.637946581],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1623",
      },
    },
    {
      type: "Feature",
      id: "sm3ceb7d30",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.122784396, 40.637932311],
            [-74.122817616, 40.64253612],
            [-74.126047058, 40.642533677],
            [-74.126013759, 40.637918893],
            [-74.122784396, 40.637932311],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1622",
      },
    },
    {
      type: "Feature",
      id: "sm876c4748",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.131087131, 40.638038062],
            [-74.126014771, 40.638059138],
            [-74.126047058, 40.642533677],
            [-74.129886814, 40.642530772],
            [-74.131045528, 40.641944623],
            [-74.131087131, 40.638038062],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1621",
      },
    },
    {
      type: "Feature",
      id: "sm3cbca393",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.126014771, 40.638059138],
            [-74.131087131, 40.638038062],
            [-74.131131362, 40.633884561],
            [-74.131131362, 40.633884561],
            [-74.129822444, 40.633135495],
            [-74.125979361, 40.633151464],
            [-74.126014771, 40.638059138],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1646",
      },
    },
    {
      type: "Feature",
      id: "sm37cea29b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070922383, 40.635662396],
            [-74.077391573, 40.635680992],
            [-74.077403385, 40.633314621],
            [-74.071457577, 40.633314621],
            [-74.070921135, 40.633900845],
            [-74.070922383, 40.635662396],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1660",
      },
    },
    {
      type: "Feature",
      id: "sm9cced7e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077258128, 40.66241004],
            [-74.070941323, 40.66239189],
            [-74.070942592, 40.664182084],
            [-74.071629238, 40.664833142],
            [-74.077245947, 40.66484928],
            [-74.077258128, 40.66241004],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1672",
      },
    },
    {
      type: "Feature",
      id: "sma0087ab5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070941323, 40.66239189],
            [-74.077258128, 40.66241004],
            [-74.07727014, 40.660004368],
            [-74.070939618, 40.659986178],
            [-74.070941323, 40.66239189],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1671",
      },
    },
    {
      type: "Feature",
      id: "sm3c4a802e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070939618, 40.659986178],
            [-74.07727014, 40.660004368],
            [-74.077282327, 40.657563588],
            [-74.070937888, 40.657545357],
            [-74.070939618, 40.659986178],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1670",
      },
    },
    {
      type: "Feature",
      id: "sm0945a37d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070937888, 40.657545357],
            [-74.077282327, 40.657563588],
            [-74.077294518, 40.655121978],
            [-74.070936158, 40.655103706],
            [-74.070937888, 40.657545357],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1669",
      },
    },
    {
      type: "Feature",
      id: "smedf53c8f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070936158, 40.655103706],
            [-74.077294518, 40.655121978],
            [-74.077306707, 40.652680772],
            [-74.070934428, 40.65266246],
            [-74.070936158, 40.655103706],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1668",
      },
    },
    {
      type: "Feature",
      id: "sma930b579",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070934428, 40.65266246],
            [-74.077306707, 40.652680772],
            [-74.077319104, 40.65019763],
            [-74.070932683, 40.650200235],
            [-74.070934428, 40.65266246],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1667",
      },
    },
    {
      type: "Feature",
      id: "smc1d8e255",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070932683, 40.650200235],
            [-74.077319104, 40.65019763],
            [-74.077330623, 40.647890347],
            [-74.070931033, 40.647871955],
            [-74.070932683, 40.650200235],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1666",
      },
    },
    {
      type: "Feature",
      id: "smb1777a07",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070931033, 40.647871955],
            [-74.077330623, 40.647890347],
            [-74.077342978, 40.645415575],
            [-74.070929279, 40.645397142],
            [-74.070931033, 40.647871955],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1665",
      },
    },
    {
      type: "Feature",
      id: "sm7e3cf221",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070929279, 40.645397142],
            [-74.077342978, 40.645415575],
            [-74.0773555, 40.642907285],
            [-74.070927502, 40.642888809],
            [-74.070929279, 40.645397142],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1664",
      },
    },
    {
      type: "Feature",
      id: "smf4f4ad6f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070927502, 40.642888809],
            [-74.0773555, 40.642907285],
            [-74.077367043, 40.640595025],
            [-74.070925864, 40.640576511],
            [-74.070927502, 40.642888809],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1663",
      },
    },
    {
      type: "Feature",
      id: "sm2a832eaf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070925864, 40.640576511],
            [-74.077367043, 40.640595025],
            [-74.077380044, 40.637990584],
            [-74.070924019, 40.637972027],
            [-74.070925864, 40.640576511],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1662",
      },
    },
    {
      type: "Feature",
      id: "sm7b84aa80",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070924019, 40.637972027],
            [-74.077380044, 40.637990584],
            [-74.077391573, 40.635680992],
            [-74.070922383, 40.635662396],
            [-74.070924019, 40.637972027],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1661",
      },
    },
    {
      type: "Feature",
      id: "sme98b27fd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.662425311],
            [-74.077258144, 40.662406711],
            [-74.077245947, 40.66484928],
            [-74.082958889, 40.664865695],
            [-74.083731365, 40.664182084],
            [-74.083731365, 40.662425311],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1647",
      },
    },
    {
      type: "Feature",
      id: "sm248b8367",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077391772, 40.63564127],
            [-74.083731366, 40.635659493],
            [-74.083731366, 40.633933413],
            [-74.083731366, 40.633933413],
            [-74.083066178, 40.633314621],
            [-74.077403385, 40.633314621],
            [-74.077391772, 40.63564127],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1659",
      },
    },
    {
      type: "Feature",
      id: "smebd16ccb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731366, 40.635659493],
            [-74.077391772, 40.63564127],
            [-74.077379743, 40.638051151],
            [-74.083731365, 40.638069408],
            [-74.083731366, 40.635659493],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1658",
      },
    },
    {
      type: "Feature",
      id: "smca1dba91",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.638069408],
            [-74.077379743, 40.638051151],
            [-74.077367397, 40.640524346],
            [-74.083731365, 40.640542638],
            [-74.083731365, 40.638069408],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1657",
      },
    },
    {
      type: "Feature",
      id: "smc67bed29",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.640542638],
            [-74.077367397, 40.640524346],
            [-74.07735505, 40.642997696],
            [-74.083731365, 40.643016023],
            [-74.083731365, 40.640542638],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1656",
      },
    },
    {
      type: "Feature",
      id: "sm16ff5314",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.643016023],
            [-74.07735505, 40.642997696],
            [-74.077342709, 40.645469721],
            [-74.083731365, 40.645488083],
            [-74.083731365, 40.643016023],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1655",
      },
    },
    {
      type: "Feature",
      id: "sm8eac2800",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.645488083],
            [-74.077342709, 40.645469721],
            [-74.077330802, 40.647854721],
            [-74.083731365, 40.647854721],
            [-74.083731365, 40.645488083],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1654",
      },
    },
    {
      type: "Feature",
      id: "sm29cff40d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.647854721],
            [-74.077330802, 40.647854721],
            [-74.077319127, 40.650193104],
            [-74.083731365, 40.650211532],
            [-74.083731365, 40.647854721],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1653",
      },
    },
    {
      type: "Feature",
      id: "sm7f52c2d3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.650211532],
            [-74.077319127, 40.650193104],
            [-74.077306257, 40.6527708],
            [-74.083731365, 40.652789265],
            [-74.083731365, 40.650211532],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1652",
      },
    },
    {
      type: "Feature",
      id: "smc30beab0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.652789265],
            [-74.077306257, 40.6527708],
            [-74.077294557, 40.655114209],
            [-74.083731365, 40.655132706],
            [-74.083731365, 40.652789265],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1651",
      },
    },
    {
      type: "Feature",
      id: "sme24fb490",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.655132706],
            [-74.077294557, 40.655114209],
            [-74.077282039, 40.6576213],
            [-74.083731365, 40.657639833],
            [-74.083731365, 40.655132706],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1650",
      },
    },
    {
      type: "Feature",
      id: "sm6a97b07e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.657639833],
            [-74.077282039, 40.6576213],
            [-74.077269848, 40.660062819],
            [-74.083731365, 40.660081386],
            [-74.083731365, 40.657639833],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1649",
      },
    },
    {
      type: "Feature",
      id: "sma038116f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083731365, 40.660081386],
            [-74.077269848, 40.660062819],
            [-74.077258144, 40.662406711],
            [-74.083731365, 40.662425311],
            [-74.083731365, 40.660081386],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1648",
      },
    },
    {
      type: "Feature",
      id: "sm32453fee",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055615649, 40.635660872],
            [-74.06233251, 40.635680784],
            [-74.062344441, 40.633362851],
            [-74.056329916, 40.633379757],
            [-74.055600355, 40.634128819],
            [-74.055615649, 40.635660872],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1686",
      },
    },
    {
      type: "Feature",
      id: "sm726433e9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062195061, 40.662377423],
            [-74.055882228, 40.662358717],
            [-74.055900763, 40.664214637],
            [-74.056801986, 40.664898248],
            [-74.062181997, 40.664914189],
            [-74.062195061, 40.662377423],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1698",
      },
    },
    {
      type: "Feature",
      id: "sm45ebd42e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055882228, 40.662358717],
            [-74.062195061, 40.662377423],
            [-74.0622073, 40.660000724],
            [-74.055858491, 40.65998191],
            [-74.055882228, 40.662358717],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1697",
      },
    },
    {
      type: "Feature",
      id: "sm69680e39",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055858491, 40.65998191],
            [-74.0622073, 40.660000724],
            [-74.062219531, 40.657625465],
            [-74.05583477, 40.657606544],
            [-74.055858491, 40.65998191],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1696",
      },
    },
    {
      type: "Feature",
      id: "smbcd764ae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05583477, 40.657606544],
            [-74.062219531, 40.657625465],
            [-74.062232439, 40.655118622],
            [-74.055809735, 40.655099588],
            [-74.05583477, 40.657606544],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1695",
      },
    },
    {
      type: "Feature",
      id: "sm7d73592b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055809735, 40.655099588],
            [-74.062232439, 40.655118622],
            [-74.062244652, 40.652746751],
            [-74.055786049, 40.65272761],
            [-74.055809735, 40.655099588],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1694",
      },
    },
    {
      type: "Feature",
      id: "smb13a9249",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055786049, 40.65272761],
            [-74.062244652, 40.652746751],
            [-74.062257919, 40.650170029],
            [-74.055760318, 40.650150771],
            [-74.055786049, 40.65272761],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1693",
      },
    },
    {
      type: "Feature",
      id: "smf6387dcf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055760318, 40.650150771],
            [-74.062257919, 40.650170029],
            [-74.062269994, 40.647824691],
            [-74.055736899, 40.647805328],
            [-74.055760318, 40.650150771],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1692",
      },
    },
    {
      type: "Feature",
      id: "sm2f125c2b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055736899, 40.647805328],
            [-74.062269994, 40.647824691],
            [-74.062282404, 40.645414275],
            [-74.055712831, 40.645394803],
            [-74.055736899, 40.647805328],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1691",
      },
    },
    {
      type: "Feature",
      id: "sm58ec92dc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055712831, 40.645394803],
            [-74.062282404, 40.645414275],
            [-74.062295647, 40.642841848],
            [-74.055687146, 40.64282226],
            [-74.055712831, 40.645394803],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1690",
      },
    },
    {
      type: "Feature",
      id: "sm45b575db",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055687146, 40.64282226],
            [-74.062295647, 40.642841848],
            [-74.062307541, 40.640531361],
            [-74.055664077, 40.640511669],
            [-74.055687146, 40.64282226],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1689",
      },
    },
    {
      type: "Feature",
      id: "sm2047fb05",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055664077, 40.640511669],
            [-74.062307541, 40.640531361],
            [-74.062320117, 40.638088371],
            [-74.055639686, 40.638068568],
            [-74.055664077, 40.640511669],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1688",
      },
    },
    {
      type: "Feature",
      id: "sm28d06298",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055639686, 40.638068568],
            [-74.062320117, 40.638088371],
            [-74.06233251, 40.635680784],
            [-74.055615649, 40.635660872],
            [-74.055639686, 40.638068568],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1687",
      },
    },
    {
      type: "Feature",
      id: "sma51c8591",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068777925, 40.662423509],
            [-74.062194924, 40.662404003],
            [-74.062181997, 40.664914189],
            [-74.067788314, 40.664930801],
            [-74.068775367, 40.664214637],
            [-74.068777925, 40.662423509],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1673",
      },
    },
    {
      type: "Feature",
      id: "smb3acec9d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062332373, 40.635707244],
            [-74.068816047, 40.635726464],
            [-74.068818281, 40.634161387],
            [-74.068818281, 40.634161387],
            [-74.067917059, 40.633347188],
            [-74.062344441, 40.633362851],
            [-74.062332373, 40.635707244],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1685",
      },
    },
    {
      type: "Feature",
      id: "sm6a1c4ab7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068816047, 40.635726464],
            [-74.062332373, 40.635707244],
            [-74.062320468, 40.63802006],
            [-74.068812745, 40.638039304],
            [-74.068816047, 40.635726464],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1684",
      },
    },
    {
      type: "Feature",
      id: "smc2262046",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068812745, 40.638039304],
            [-74.062320468, 40.63802006],
            [-74.062307555, 40.640528563],
            [-74.068809164, 40.640547834],
            [-74.068812745, 40.638039304],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1683",
      },
    },
    {
      type: "Feature",
      id: "sm40a3fa73",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068809164, 40.640547834],
            [-74.062307555, 40.640528563],
            [-74.062295506, 40.642869068],
            [-74.068805822, 40.642888365],
            [-74.068809164, 40.640547834],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1682",
      },
    },
    {
      type: "Feature",
      id: "smca3c0982",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068805822, 40.642888365],
            [-74.062295506, 40.642869068],
            [-74.062282244, 40.645445058],
            [-74.068802144, 40.645464382],
            [-74.068805822, 40.642888365],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1681",
      },
    },
    {
      type: "Feature",
      id: "sm3114ffc9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068802144, 40.645464382],
            [-74.062282244, 40.645445058],
            [-74.06226984, 40.647854328],
            [-74.068798704, 40.647873678],
            [-74.068802144, 40.645464382],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1680",
      },
    },
    {
      type: "Feature",
      id: "sm03411e94",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068798704, 40.647873678],
            [-74.06226984, 40.647854328],
            [-74.062257614, 40.650228917],
            [-74.068795313, 40.650248293],
            [-74.068798704, 40.647873678],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1679",
      },
    },
    {
      type: "Feature",
      id: "sm0660a234",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068795313, 40.650248293],
            [-74.062257614, 40.650228917],
            [-74.062244692, 40.652738614],
            [-74.068791729, 40.652758017],
            [-74.068795313, 40.650248293],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1678",
      },
    },
    {
      type: "Feature",
      id: "smb18cab28",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068791729, 40.652758017],
            [-74.062244692, 40.652738614],
            [-74.062232168, 40.655171021],
            [-74.068788255, 40.65519045],
            [-74.068791729, 40.652758017],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1677",
      },
    },
    {
      type: "Feature",
      id: "smb1fa4ac7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068788255, 40.65519045],
            [-74.062232168, 40.655171021],
            [-74.06221889, 40.657749713],
            [-74.068784572, 40.65776917],
            [-74.068788255, 40.65519045],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1676",
      },
    },
    {
      type: "Feature",
      id: "sm76454ad4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068784572, 40.65776917],
            [-74.06221889, 40.657749713],
            [-74.062207493, 40.659963085],
            [-74.068781411, 40.659982565],
            [-74.068784572, 40.65776917],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1675",
      },
    },
    {
      type: "Feature",
      id: "sm257ac090",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.068781411, 40.659982565],
            [-74.062207493, 40.659963085],
            [-74.062194924, 40.662404003],
            [-74.068777925, 40.662423509],
            [-74.068781411, 40.659982565],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1674",
      },
    },
    {
      type: "Feature",
      id: "sm7a648844",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040615076, 40.635643209],
            [-74.047038745, 40.635643209],
            [-74.047038745, 40.633248764],
            [-74.041352459, 40.633216917],
            [-74.040622898, 40.633803142],
            [-74.040615076, 40.635643209],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1712",
      },
    },
    {
      type: "Feature",
      id: "sm4076eaaf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047038745, 40.662390491],
            [-74.040501424, 40.662374495],
            [-74.040494153, 40.664084425],
            [-74.041395375, 40.664995906],
            [-74.047038745, 40.664995906],
            [-74.047038745, 40.662390491],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1724",
      },
    },
    {
      type: "Feature",
      id: "smc5cbb051",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040501424, 40.662374495],
            [-74.047038745, 40.662390491],
            [-74.047038745, 40.659981035],
            [-74.04051167, 40.659965063],
            [-74.040501424, 40.662374495],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1723",
      },
    },
    {
      type: "Feature",
      id: "smf3ee4f39",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.04051167, 40.659965063],
            [-74.047038745, 40.659981035],
            [-74.047038745, 40.657701822],
            [-74.040521362, 40.657685873],
            [-74.04051167, 40.659965063],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1722",
      },
    },
    {
      type: "Feature",
      id: "smdd89c865",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040521362, 40.657685873],
            [-74.047038745, 40.657701822],
            [-74.047038745, 40.655194839],
            [-74.040532022, 40.655178915],
            [-74.040521362, 40.657685873],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1721",
      },
    },
    {
      type: "Feature",
      id: "sma8340974",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040532022, 40.655178915],
            [-74.047038745, 40.655194839],
            [-74.047038745, 40.652718219],
            [-74.040542552, 40.652702321],
            [-74.040532022, 40.655178915],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1720",
      },
    },
    {
      type: "Feature",
      id: "sm92f9637d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040542552, 40.652702321],
            [-74.047038745, 40.652718219],
            [-74.047038745, 40.650329314],
            [-74.040552642, 40.650329314],
            [-74.040542552, 40.652702321],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1719",
      },
    },
    {
      type: "Feature",
      id: "smb916606f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040552642, 40.650329314],
            [-74.047038745, 40.650329314],
            [-74.047038745, 40.647789598],
            [-74.04056344, 40.647789598],
            [-74.040552642, 40.650329314],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1718",
      },
    },
    {
      type: "Feature",
      id: "sm68ba035c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.04056344, 40.647789598],
            [-74.047038745, 40.647789598],
            [-74.047038745, 40.645412596],
            [-74.040573546, 40.645412596],
            [-74.04056344, 40.647789598],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1717",
      },
    },
    {
      type: "Feature",
      id: "sm257731c6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040573546, 40.645412596],
            [-74.047038745, 40.645412596],
            [-74.047038745, 40.64293782],
            [-74.040584067, 40.64293782],
            [-74.040573546, 40.645412596],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1716",
      },
    },
    {
      type: "Feature",
      id: "sm69a184b3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040584067, 40.64293782],
            [-74.047038745, 40.64293782],
            [-74.047038745, 40.640462952],
            [-74.040594588, 40.640462952],
            [-74.040584067, 40.64293782],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1715",
      },
    },
    {
      type: "Feature",
      id: "sm7f79c924",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040594588, 40.640462952],
            [-74.047038745, 40.640462952],
            [-74.047038745, 40.638150821],
            [-74.040604417, 40.638150821],
            [-74.040594588, 40.640462952],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1714",
      },
    },
    {
      type: "Feature",
      id: "smcb41976a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040604417, 40.638150821],
            [-74.047038745, 40.638150821],
            [-74.047038745, 40.635643209],
            [-74.040615076, 40.635643209],
            [-74.040604417, 40.638150821],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1713",
      },
    },
    {
      type: "Feature",
      id: "sm4778e6d4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.662473029],
            [-74.047038745, 40.662473029],
            [-74.047038745, 40.664995906],
            [-74.052682111, 40.664995906],
            [-74.053712079, 40.664214637],
            [-74.053712079, 40.662473029],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1699",
      },
    },
    {
      type: "Feature",
      id: "sm8b1e5759",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047038745, 40.635675776],
            [-74.053712078, 40.635675776],
            [-74.053712078, 40.633965982],
            [-74.053712078, 40.633965982],
            [-74.052982517, 40.633282054],
            [-74.047038745, 40.633248764],
            [-74.047038745, 40.635675776],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1711",
      },
    },
    {
      type: "Feature",
      id: "smfb2a9d88",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712078, 40.635675776],
            [-74.047038745, 40.635675776],
            [-74.047038745, 40.638248518],
            [-74.053712079, 40.638248518],
            [-74.053712078, 40.635675776],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1710",
      },
    },
    {
      type: "Feature",
      id: "sma756ddc7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.638248518],
            [-74.047038745, 40.638248518],
            [-74.047038745, 40.640560646],
            [-74.053712079, 40.640560646],
            [-74.053712079, 40.638248518],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1709",
      },
    },
    {
      type: "Feature",
      id: "sm24ee5818",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.640560646],
            [-74.047038745, 40.640560646],
            [-74.047038745, 40.642905257],
            [-74.053712079, 40.642905257],
            [-74.053712079, 40.640560646],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1708",
      },
    },
    {
      type: "Feature",
      id: "smc20da170",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.642905257],
            [-74.047038745, 40.642905257],
            [-74.047038745, 40.645510282],
            [-74.053712079, 40.645510282],
            [-74.053712079, 40.642905257],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1707",
      },
    },
    {
      type: "Feature",
      id: "sm63db3835",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.645510282],
            [-74.047038745, 40.645510282],
            [-74.047038745, 40.647854719],
            [-74.053712079, 40.647854719],
            [-74.053712079, 40.645510282],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1706",
      },
    },
    {
      type: "Feature",
      id: "smda483e47",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.647854719],
            [-74.047038745, 40.647854719],
            [-74.047038745, 40.650231634],
            [-74.053712079, 40.650231634],
            [-74.053712079, 40.647854719],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1705",
      },
    },
    {
      type: "Feature",
      id: "smadbcb713",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.650231634],
            [-74.047038745, 40.650231634],
            [-74.047038745, 40.652771257],
            [-74.053712079, 40.652771257],
            [-74.053712079, 40.650231634],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1704",
      },
    },
    {
      type: "Feature",
      id: "sm9e526508",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.652771257],
            [-74.047038745, 40.652771257],
            [-74.047038745, 40.655115437],
            [-74.053712079, 40.655115437],
            [-74.053712079, 40.652771257],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1703",
      },
    },
    {
      type: "Feature",
      id: "sm3d6c753e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.655115437],
            [-74.047038745, 40.655115437],
            [-74.047038745, 40.657687431],
            [-74.053712079, 40.657687431],
            [-74.053712079, 40.655115437],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1702",
      },
    },
    {
      type: "Feature",
      id: "smea94596e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.657687431],
            [-74.047038745, 40.657687431],
            [-74.047038745, 40.660063995],
            [-74.053712079, 40.660063995],
            [-74.053712079, 40.657687431],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1701",
      },
    },
    {
      type: "Feature",
      id: "sm314c5e02",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053712079, 40.660063995],
            [-74.047038745, 40.660063995],
            [-74.047038745, 40.662473029],
            [-74.053712079, 40.662473029],
            [-74.053712079, 40.660063995],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1700",
      },
    },
    {
      type: "Feature",
      id: "smf4062074",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025550043, 40.635644976],
            [-74.032169475, 40.635682463],
            [-74.032194354, 40.63315256],
            [-74.026503747, 40.633119212],
            [-74.02555961, 40.633965981],
            [-74.025550043, 40.635644976],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1738",
      },
    },
    {
      type: "Feature",
      id: "smf89b4739",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031904381, 40.662633818],
            [-74.02539643, 40.662596976],
            [-74.02538795, 40.664084425],
            [-74.026160426, 40.664865695],
            [-74.031882104, 40.664898084],
            [-74.031904381, 40.662633818],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1750",
      },
    },
    {
      type: "Feature",
      id: "sme26f4e3e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02539643, 40.662596976],
            [-74.031904381, 40.662633818],
            [-74.031930015, 40.660028177],
            [-74.025411195, 40.660006793],
            [-74.02539643, 40.662596976],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1749",
      },
    },
    {
      type: "Feature",
      id: "smd0a6b186",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025411195, 40.660006793],
            [-74.031930015, 40.660028177],
            [-74.031953044, 40.6576872],
            [-74.02542454, 40.657665783],
            [-74.025411195, 40.660006793],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1748",
      },
    },
    {
      type: "Feature",
      id: "sm814f3c09",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02542454, 40.657665783],
            [-74.031953044, 40.6576872],
            [-74.031978334, 40.655116275],
            [-74.025439195, 40.655094822],
            [-74.02542454, 40.657665783],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1747",
      },
    },
    {
      type: "Feature",
      id: "smeea12496",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025439195, 40.655094822],
            [-74.031978334, 40.655116275],
            [-74.03200171, 40.652739892],
            [-74.02545274, 40.652718407],
            [-74.025439195, 40.655094822],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1746",
      },
    },
    {
      type: "Feature",
      id: "sm4f0345d2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02545274, 40.652718407],
            [-74.03200171, 40.652739892],
            [-74.03202411, 40.650462621],
            [-74.025465809, 40.650425488],
            [-74.02545274, 40.652718407],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1745",
      },
    },
    {
      type: "Feature",
      id: "smd1e3785a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025465809, 40.650425488],
            [-74.03202411, 40.650462621],
            [-74.032048754, 40.64795719],
            [-74.025480089, 40.647919997],
            [-74.025465809, 40.650425488],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1744",
      },
    },
    {
      type: "Feature",
      id: "smc59aeead",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025480089, 40.647919997],
            [-74.032048754, 40.64795719],
            [-74.032073088, 40.645483133],
            [-74.02549419, 40.64544588],
            [-74.025480089, 40.647919997],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1743",
      },
    },
    {
      type: "Feature",
      id: "sm45e24fa9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02549419, 40.64544588],
            [-74.032073088, 40.645483133],
            [-74.032098395, 40.642910083],
            [-74.025508854, 40.642872769],
            [-74.02549419, 40.64544588],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1742",
      },
    },
    {
      type: "Feature",
      id: "smcdb7514e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025508854, 40.642872769],
            [-74.032098395, 40.642910083],
            [-74.032121462, 40.640564631],
            [-74.025522221, 40.64052726],
            [-74.025508854, 40.642872769],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1741",
      },
    },
    {
      type: "Feature",
      id: "sm4235b7bf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025522221, 40.64052726],
            [-74.032121462, 40.640564631],
            [-74.032144522, 40.638219825],
            [-74.025535584, 40.638182399],
            [-74.025522221, 40.64052726],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1740",
      },
    },
    {
      type: "Feature",
      id: "smf004c0ec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025535584, 40.638182399],
            [-74.032144522, 40.638219825],
            [-74.032169475, 40.635682463],
            [-74.025550043, 40.635644976],
            [-74.025535584, 40.638182399],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1739",
      },
    },
    {
      type: "Feature",
      id: "sm6d4e297d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.662659245],
            [-74.031904501, 40.662621552],
            [-74.031882104, 40.664898084],
            [-74.037661738, 40.664930801],
            [-74.038562961, 40.66424719],
            [-74.038562961, 40.662659245],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1725",
      },
    },
    {
      type: "Feature",
      id: "sm7fa054dd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.032169251, 40.635705307],
            [-74.038562959, 40.635741516],
            [-74.038562959, 40.634031116],
            [-74.038562959, 40.634031116],
            [-74.037618821, 40.633184348],
            [-74.032194354, 40.63315256],
            [-74.032169251, 40.635705307],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1737",
      },
    },
    {
      type: "Feature",
      id: "sm17eb2152",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562959, 40.635741516],
            [-74.032169251, 40.635705307],
            [-74.032144568, 40.638215208],
            [-74.03856296, 40.638251555],
            [-74.038562959, 40.635741516],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1736",
      },
    },
    {
      type: "Feature",
      id: "sm0cc43463",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03856296, 40.638251555],
            [-74.032144568, 40.638215208],
            [-74.032121553, 40.640555397],
            [-74.03856296, 40.640591873],
            [-74.03856296, 40.638251555],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1735",
      },
    },
    {
      type: "Feature",
      id: "smd79da157",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03856296, 40.640591873],
            [-74.032121553, 40.640555397],
            [-74.032098505, 40.642898905],
            [-74.038562961, 40.642935511],
            [-74.03856296, 40.640591873],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1734",
      },
    },
    {
      type: "Feature",
      id: "sm4d66e9cf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.642935511],
            [-74.032098505, 40.642898905],
            [-74.032071556, 40.645638888],
            [-74.038562961, 40.645675645],
            [-74.038562961, 40.642935511],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1733",
      },
    },
    {
      type: "Feature",
      id: "sm3df05d4e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.645675645],
            [-74.032071556, 40.645638888],
            [-74.032048806, 40.647951845],
            [-74.038562961, 40.64798873],
            [-74.038562961, 40.645675645],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1732",
      },
    },
    {
      type: "Feature",
      id: "sm9357efc3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.64798873],
            [-74.032048806, 40.647951845],
            [-74.032023827, 40.650491414],
            [-74.038562961, 40.650528438],
            [-74.038562961, 40.64798873],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1731",
      },
    },
    {
      type: "Feature",
      id: "sm5149e5a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.650528438],
            [-74.032023827, 40.650491414],
            [-74.032001149, 40.652796915],
            [-74.038562961, 40.652834066],
            [-74.038562961, 40.650528438],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1730",
      },
    },
    {
      type: "Feature",
      id: "smecc4b0d8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.652834066],
            [-74.032001149, 40.652796915],
            [-74.031978414, 40.655108168],
            [-74.038562961, 40.655145447],
            [-74.038562961, 40.652834066],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1729",
      },
    },
    {
      type: "Feature",
      id: "smae1cda0d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.655145447],
            [-74.031978414, 40.655108168],
            [-74.031953126, 40.657678804],
            [-74.038562961, 40.657716224],
            [-74.038562961, 40.655145447],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1728",
      },
    },
    {
      type: "Feature",
      id: "sm50e1ad7b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.657716224],
            [-74.031953126, 40.657678804],
            [-74.031929784, 40.660051592],
            [-74.038562961, 40.660089143],
            [-74.038562961, 40.657716224],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1727",
      },
    },
    {
      type: "Feature",
      id: "smfd9a2912",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038562961, 40.660089143],
            [-74.031929784, 40.660051592],
            [-74.031904501, 40.662621552],
            [-74.038562961, 40.662659245],
            [-74.038562961, 40.660089143],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1726",
      },
    },
    {
      type: "Feature",
      id: "smee46b5ec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020409747, 40.655210362],
            [-74.020400402, 40.660047717],
            [-74.023499673, 40.660047717],
            [-74.023499674, 40.655864252],
            [-74.023499674, 40.655864252],
            [-74.022877402, 40.655213106],
            [-74.020409747, 40.655210362],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1778",
      },
    },
    {
      type: "Feature",
      id: "sm2d2cd2ef",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020400402, 40.660047717],
            [-74.020409747, 40.655210362],
            [-74.016977345, 40.655206546],
            [-74.016967992, 40.660047716],
            [-74.020400402, 40.660047717],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1777",
      },
    },
    {
      type: "Feature",
      id: "smf3bb4fd8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016967992, 40.660047716],
            [-74.016977345, 40.655206546],
            [-74.014016067, 40.655203253],
            [-74.014006707, 40.660047716],
            [-74.016967992, 40.660047716],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1776",
      },
    },
    {
      type: "Feature",
      id: "smf7418149",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014006707, 40.660047716],
            [-74.014016067, 40.655203253],
            [-74.010497771, 40.655199341],
            [-74.010488404, 40.660047715],
            [-74.014006707, 40.660047716],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1775",
      },
    },
    {
      type: "Feature",
      id: "sm31e1e7e2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010488404, 40.660047715],
            [-74.010497771, 40.655199341],
            [-74.007278938, 40.655195762],
            [-74.007269564, 40.660047715],
            [-74.010488404, 40.660047715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1774",
      },
    },
    {
      type: "Feature",
      id: "sm5005d4b1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007269564, 40.660047715],
            [-74.007278938, 40.655195762],
            [-74.003974212, 40.655192088],
            [-74.003964831, 40.660047714],
            [-74.007269564, 40.660047715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1773",
      },
    },
    {
      type: "Feature",
      id: "sm998d9040",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003964831, 40.660047714],
            [-74.003974212, 40.655192088],
            [-74.000711521, 40.65518846],
            [-74.000702133, 40.660047714],
            [-74.003964831, 40.660047714],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1772",
      },
    },
    {
      type: "Feature",
      id: "sm9d29e2bb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.000702133, 40.660047714],
            [-74.000711521, 40.65518846],
            [-73.997449962, 40.655184834],
            [-73.997440567, 40.660047713],
            [-74.000702133, 40.660047714],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1771",
      },
    },
    {
      type: "Feature",
      id: "sm023d44c4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997440567, 40.660047713],
            [-73.997449962, 40.655184834],
            [-73.994188591, 40.655181208],
            [-73.994179189, 40.660047712],
            [-73.997440567, 40.660047713],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1770",
      },
    },
    {
      type: "Feature",
      id: "sm371f1e44",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994179189, 40.660047712],
            [-73.994188591, 40.655181208],
            [-73.99101368, 40.655177678],
            [-73.991004272, 40.660047712],
            [-73.994179189, 40.660047712],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1769",
      },
    },
    {
      type: "Feature",
      id: "smc073577f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991004272, 40.660047712],
            [-73.99101368, 40.655177678],
            [-73.987579454, 40.65517386],
            [-73.987570038, 40.660047711],
            [-73.991004272, 40.660047712],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1768",
      },
    },
    {
      type: "Feature",
      id: "smf30706df",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.987570038, 40.660047711],
            [-73.987579454, 40.65517386],
            [-73.984489555, 40.655170425],
            [-73.984480133, 40.660047711],
            [-73.987570038, 40.660047711],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1767",
      },
    },
    {
      type: "Feature",
      id: "sm6ba4abfb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984480133, 40.660047711],
            [-73.984489555, 40.655170425],
            [-73.981228751, 40.6551668],
            [-73.981219322, 40.660047711],
            [-73.984480133, 40.660047711],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1766",
      },
    },
    {
      type: "Feature",
      id: "smd097f0a7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981219322, 40.660047711],
            [-73.981228751, 40.6551668],
            [-73.978953546, 40.65516427],
            [-73.978138155, 40.655750302],
            [-73.978181898, 40.660047711],
            [-73.981219322, 40.660047711],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1765",
      },
    },
    {
      type: "Feature",
      id: "sme4eece47",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981185148, 40.664804037],
            [-73.98118515, 40.660047711],
            [-73.978181898, 40.660047711],
            [-73.978223985, 40.664182084],
            [-73.978867715, 40.66480059],
            [-73.981185148, 40.664804037],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1764",
      },
    },
    {
      type: "Feature",
      id: "sm3438c9e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.98118515, 40.660047711],
            [-73.981185148, 40.664804037],
            [-73.984661292, 40.664809207],
            [-73.984661293, 40.660047712],
            [-73.98118515, 40.660047711],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1763",
      },
    },
    {
      type: "Feature",
      id: "smdb4d1837",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984661293, 40.660047712],
            [-73.984661292, 40.664809207],
            [-73.987708281, 40.664813739],
            [-73.987708282, 40.660047712],
            [-73.984661293, 40.660047712],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1762",
      },
    },
    {
      type: "Feature",
      id: "sme505d996",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.987708282, 40.660047712],
            [-73.987708281, 40.664813739],
            [-73.991012762, 40.664818654],
            [-73.991012764, 40.660047713],
            [-73.987708282, 40.660047712],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1761",
      },
    },
    {
      type: "Feature",
      id: "smf98a3505",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991012764, 40.660047713],
            [-73.991012762, 40.664818654],
            [-73.994145582, 40.664823313],
            [-73.994145584, 40.660047713],
            [-73.991012764, 40.660047713],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1760",
      },
    },
    {
      type: "Feature",
      id: "sme9fdf7d2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994145584, 40.660047713],
            [-73.994145582, 40.664823313],
            [-73.997621725, 40.664828483],
            [-73.997621726, 40.660047714],
            [-73.994145584, 40.660047713],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1759",
      },
    },
    {
      type: "Feature",
      id: "sm97d12ed4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997621726, 40.660047714],
            [-73.997621725, 40.664828483],
            [-74.000797461, 40.664833206],
            [-74.000797462, 40.660047715],
            [-73.997621726, 40.660047714],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1758",
      },
    },
    {
      type: "Feature",
      id: "sm44644b6e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.000797462, 40.660047715],
            [-74.000797461, 40.664833206],
            [-74.003973196, 40.664837929],
            [-74.003973198, 40.660047715],
            [-74.000797462, 40.660047715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1757",
      },
    },
    {
      type: "Feature",
      id: "smd815994b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003973198, 40.660047715],
            [-74.003973196, 40.664837929],
            [-74.007320593, 40.664842908],
            [-74.007320594, 40.660047716],
            [-74.003973198, 40.660047715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1756",
      },
    },
    {
      type: "Feature",
      id: "sm290904a3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007320594, 40.660047716],
            [-74.007320593, 40.664842908],
            [-74.010410498, 40.664847504],
            [-74.010410499, 40.660047716],
            [-74.007320594, 40.660047716],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1755",
      },
    },
    {
      type: "Feature",
      id: "smb84441a8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010410499, 40.660047716],
            [-74.010410498, 40.664847504],
            [-74.013929556, 40.664852738],
            [-74.013929557, 40.660047717],
            [-74.010410499, 40.660047716],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1754",
      },
    },
    {
      type: "Feature",
      id: "sm3ccf15a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013929557, 40.660047717],
            [-74.013929556, 40.664852738],
            [-74.017062376, 40.664857397],
            [-74.017062377, 40.660047717],
            [-74.013929557, 40.660047717],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1753",
      },
    },
    {
      type: "Feature",
      id: "smfed34c5d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017062377, 40.660047717],
            [-74.017062376, 40.664857397],
            [-74.020323943, 40.664862248],
            [-74.020323944, 40.660047717],
            [-74.017062377, 40.660047717],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1752",
      },
    },
    {
      type: "Feature",
      id: "sm7f62aa1c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020323944, 40.660047717],
            [-74.020323943, 40.664862248],
            [-74.022641366, 40.664865695],
            [-74.023499672, 40.664214637],
            [-74.023499673, 40.660047717],
            [-74.020323944, 40.660047717],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1751",
      },
    },
    {
      type: "Feature",
      id: "smdf68ee8a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020127095, 40.643677155],
            [-74.020149775, 40.648685021],
            [-74.023628419, 40.64868502],
            [-74.023628418, 40.644451998],
            [-74.023628418, 40.644451998],
            [-74.02268428, 40.643670488],
            [-74.020127095, 40.643677155],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1806",
      },
    },
    {
      type: "Feature",
      id: "sm7c304b32",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020149775, 40.648685021],
            [-74.020127095, 40.643677155],
            [-74.016864977, 40.643685661],
            [-74.01688762, 40.648685021],
            [-74.020149775, 40.648685021],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1805",
      },
    },
    {
      type: "Feature",
      id: "sm718455c3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01688762, 40.648685021],
            [-74.016864977, 40.643685661],
            [-74.01351821, 40.643694388],
            [-74.013540813, 40.648685022],
            [-74.01688762, 40.648685021],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1804",
      },
    },
    {
      type: "Feature",
      id: "sm18bfcfe0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013540813, 40.648685022],
            [-74.01351821, 40.643694388],
            [-74.010558266, 40.643702106],
            [-74.010580834, 40.648685022],
            [-74.013540813, 40.648685022],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1803",
      },
    },
    {
      type: "Feature",
      id: "smec1632e3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010580834, 40.648685022],
            [-74.010558266, 40.643702106],
            [-74.007082312, 40.64371117],
            [-74.007104839, 40.648685023],
            [-74.010580834, 40.648685022],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1802",
      },
    },
    {
      type: "Feature",
      id: "sm5a39f204",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007104839, 40.648685023],
            [-74.007082312, 40.64371117],
            [-74.003863846, 40.643719562],
            [-74.003886335, 40.648685023],
            [-74.007104839, 40.648685023],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1801",
      },
    },
    {
      type: "Feature",
      id: "sm8264da9d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003886335, 40.648685023],
            [-74.003863846, 40.643719562],
            [-74.000603203, 40.643728064],
            [-74.000625654, 40.648685024],
            [-74.003886335, 40.648685023],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1800",
      },
    },
    {
      type: "Feature",
      id: "sm28e8977a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.000625654, 40.648685024],
            [-74.000603203, 40.643728064],
            [-73.997599458, 40.643735896],
            [-73.997621873, 40.648685024],
            [-74.000625654, 40.648685024],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1799",
      },
    },
    {
      type: "Feature",
      id: "sm74788611",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997621873, 40.648685024],
            [-73.997599458, 40.643735896],
            [-73.994165829, 40.643744849],
            [-73.994188203, 40.648685025],
            [-73.997621873, 40.648685024],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1798",
      },
    },
    {
      type: "Feature",
      id: "sm7cfeab38",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994188203, 40.648685025],
            [-73.994165829, 40.643744849],
            [-73.990991753, 40.643753125],
            [-73.99101409, 40.648685025],
            [-73.994188203, 40.648685025],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1797",
      },
    },
    {
      type: "Feature",
      id: "sma4da2df2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99101409, 40.648685025],
            [-73.990991753, 40.643753125],
            [-73.987643142, 40.643761856],
            [-73.98766544, 40.648685026],
            [-73.99101409, 40.648685025],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1796",
      },
    },
    {
      type: "Feature",
      id: "sm5422d130",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.98766544, 40.648685026],
            [-73.987643142, 40.643761856],
            [-73.984552832, 40.643769914],
            [-73.984575092, 40.648685026],
            [-73.98766544, 40.648685026],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1795",
      },
    },
    {
      type: "Feature",
      id: "smadede495",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984575092, 40.648685026],
            [-73.984552832, 40.643769914],
            [-73.981076287, 40.643778979],
            [-73.981098507, 40.648685026],
            [-73.984575092, 40.648685026],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1794",
      },
    },
    {
      type: "Feature",
      id: "sme4ce2da1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981098507, 40.648685026],
            [-73.981076287, 40.643778979],
            [-73.978975003, 40.643784458],
            [-73.9782669, 40.644338027],
            [-73.978212023, 40.648685026],
            [-73.981098507, 40.648685026],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1793",
      },
    },
    {
      type: "Feature",
      id: "sm62b1cc3c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981142235, 40.653426852],
            [-73.981142234, 40.648685026],
            [-73.978212023, 40.648685026],
            [-73.978159612, 40.652836369],
            [-73.978738969, 40.653422422],
            [-73.981142235, 40.653426852],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1792",
      },
    },
    {
      type: "Feature",
      id: "sm63758ab8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981142234, 40.648685026],
            [-73.981142235, 40.653426852],
            [-73.984618378, 40.653433259],
            [-73.984618377, 40.648685025],
            [-73.981142234, 40.648685026],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1791",
      },
    },
    {
      type: "Feature",
      id: "sm923a55d4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984618377, 40.648685025],
            [-73.984618378, 40.653433259],
            [-73.987751198, 40.653439034],
            [-73.987751197, 40.648685025],
            [-73.984618377, 40.648685025],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1790",
      },
    },
    {
      type: "Feature",
      id: "sm2d04e64a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.987751197, 40.648685025],
            [-73.987751198, 40.653439034],
            [-73.990969849, 40.653444967],
            [-73.990969848, 40.648685024],
            [-73.987751197, 40.648685025],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1789",
      },
    },
    {
      type: "Feature",
      id: "smb96ca7de",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.990969848, 40.648685024],
            [-73.990969849, 40.653444967],
            [-73.994231415, 40.653450979],
            [-73.994231414, 40.648685024],
            [-73.990969848, 40.648685024],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1788",
      },
    },
    {
      type: "Feature",
      id: "sm1d9f4428",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994231414, 40.648685024],
            [-73.994231415, 40.653450979],
            [-73.997664643, 40.653457307],
            [-73.997664642, 40.648685023],
            [-73.994231414, 40.648685024],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1787",
      },
    },
    {
      type: "Feature",
      id: "smb5087d5a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997664642, 40.648685023],
            [-73.997664643, 40.653457307],
            [-74.000754548, 40.653463002],
            [-74.000754546, 40.648685023],
            [-73.997664642, 40.648685023],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1786",
      },
    },
    {
      type: "Feature",
      id: "sm14451959",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.000754546, 40.648685023],
            [-74.000754548, 40.653463002],
            [-74.004187775, 40.65346933],
            [-74.004187774, 40.648685022],
            [-74.000754546, 40.648685023],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1785",
      },
    },
    {
      type: "Feature",
      id: "sm472f4e13",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004187774, 40.648685022],
            [-74.004187775, 40.65346933],
            [-74.007148934, 40.653474788],
            [-74.007148933, 40.648685022],
            [-74.004187774, 40.648685022],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1784",
      },
    },
    {
      type: "Feature",
      id: "sm6ceab7cc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007148933, 40.648685022],
            [-74.007148934, 40.653474788],
            [-74.010710908, 40.653481353],
            [-74.010710906, 40.648685021],
            [-74.007148933, 40.648685022],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1783",
      },
    },
    {
      type: "Feature",
      id: "sm6375be71",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010710906, 40.648685021],
            [-74.010710908, 40.653481353],
            [-74.013929558, 40.653487286],
            [-74.013929557, 40.64868502],
            [-74.010710906, 40.648685021],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1782",
      },
    },
    {
      type: "Feature",
      id: "smb2e3d00a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013929557, 40.64868502],
            [-74.013929558, 40.653487286],
            [-74.017062378, 40.65349306],
            [-74.017062377, 40.64868502],
            [-74.013929557, 40.64868502],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1781",
      },
    },
    {
      type: "Feature",
      id: "sme5d4ead8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017062377, 40.64868502],
            [-74.017062378, 40.65349306],
            [-74.020495606, 40.653499388],
            [-74.020495605, 40.64868502],
            [-74.017062377, 40.64868502],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1780",
      },
    },
    {
      type: "Feature",
      id: "sm05c03160",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020495605, 40.64868502],
            [-74.020495606, 40.653499388],
            [-74.022898859, 40.653503818],
            [-74.02362842, 40.652934045],
            [-74.023628419, 40.64868502],
            [-74.020495605, 40.64868502],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1779",
      },
    },
    {
      type: "Feature",
      id: "smf9b31a1c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.977969526, 40.63719322],
            [-73.984319383, 40.637212265],
            [-73.984339737, 40.633304441],
            [-73.978846257, 40.633298337],
            [-73.97798795, 40.633949697],
            [-73.977969526, 40.63719322],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1820",
      },
    },
    {
      type: "Feature",
      id: "sm8a86a9f5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984319383, 40.637212265],
            [-73.977969526, 40.63719322],
            [-73.977953977, 40.639930613],
            [-73.984305125, 40.639949662],
            [-73.984319383, 40.637212265],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1819",
      },
    },
    {
      type: "Feature",
      id: "smbf27eb99",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984305125, 40.639949662],
            [-73.977953977, 40.639930613],
            [-73.977945034, 40.641505006],
            [-73.978932087, 40.642221414],
            [-73.984293208, 40.642237493],
            [-73.984305125, 40.639949662],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1818",
      },
    },
    {
      type: "Feature",
      id: "smd4f604e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.988058552, 40.642248786],
            [-73.988082882, 40.637780652],
            [-73.984316484, 40.637768842],
            [-73.984293208, 40.642237493],
            [-73.988058552, 40.642248786],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1817",
      },
    },
    {
      type: "Feature",
      id: "smbae2c183",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.988082882, 40.637780652],
            [-73.988058552, 40.642248786],
            [-73.991490305, 40.642259079],
            [-73.991514633, 40.637791412],
            [-73.988082882, 40.637780652],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1816",
      },
    },
    {
      type: "Feature",
      id: "sm7d1bd60f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991514633, 40.637791412],
            [-73.991490305, 40.642259079],
            [-73.995094957, 40.64226989],
            [-73.995119283, 40.637802715],
            [-73.991514633, 40.637791412],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1815",
      },
    },
    {
      type: "Feature",
      id: "sm3a91e86d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.995119283, 40.637802715],
            [-73.995094957, 40.64226989],
            [-73.998654745, 40.642280566],
            [-73.998679068, 40.637813877],
            [-73.995119283, 40.637802715],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1814",
      },
    },
    {
      type: "Feature",
      id: "smf085a3af",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998679068, 40.637813877],
            [-73.998654745, 40.642280566],
            [-74.00230178, 40.642291504],
            [-74.0023261, 40.637825313],
            [-73.998679068, 40.637813877],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1813",
      },
    },
    {
      type: "Feature",
      id: "sm4d32dc1f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0023261, 40.637825313],
            [-74.00230178, 40.642291504],
            [-74.005732469, 40.642301793],
            [-74.005756787, 40.63783607],
            [-74.0023261, 40.637825313],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1812",
      },
    },
    {
      type: "Feature",
      id: "sm5ebe32ab",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005756787, 40.63783607],
            [-74.005732469, 40.642301793],
            [-74.009166882, 40.642312093],
            [-74.009191197, 40.637846839],
            [-74.005756787, 40.63783607],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1811",
      },
    },
    {
      type: "Feature",
      id: "sma9be6379",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009191197, 40.637846839],
            [-74.009166882, 40.642312093],
            [-74.012771357, 40.642322903],
            [-74.01279567, 40.637858141],
            [-74.009191197, 40.637846839],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1810",
      },
    },
    {
      type: "Feature",
      id: "smd50a94a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01279567, 40.637858141],
            [-74.012771357, 40.642322903],
            [-74.016418392, 40.642333841],
            [-74.016442702, 40.637869577],
            [-74.01279567, 40.637858141],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1809",
      },
    },
    {
      type: "Feature",
      id: "sm93dce2a4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016442702, 40.637869577],
            [-74.016418392, 40.642333841],
            [-74.019937571, 40.642344396],
            [-74.019961878, 40.637880612],
            [-74.016442702, 40.637869577],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1808",
      },
    },
    {
      type: "Feature",
      id: "sm64a7f2a7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019961878, 40.637880612],
            [-74.019937571, 40.642344396],
            [-74.022362415, 40.642351669],
            [-74.023435298, 40.641505006],
            [-74.023499674, 40.637939137],
            [-74.023499932, 40.637891706],
            [-74.019961878, 40.637880612],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1807",
      },
    },
    {
      type: "Feature",
      id: "smd0ef2831",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019660682, 40.633343686],
            [-74.01965193, 40.63787964],
            [-74.023499932, 40.637891706],
            [-74.023521131, 40.633998549],
            [-74.022813028, 40.633347189],
            [-74.019660682, 40.633343686],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1831",
      },
    },
    {
      type: "Feature",
      id: "sm592560fb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01965193, 40.63787964],
            [-74.019660682, 40.633343686],
            [-74.016227713, 40.633339872],
            [-74.016218975, 40.637868876],
            [-74.01965193, 40.63787964],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1830",
      },
    },
    {
      type: "Feature",
      id: "smbcc07f53",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016218975, 40.637868876],
            [-74.016227713, 40.633339872],
            [-74.01270772, 40.633335961],
            [-74.012698995, 40.637857839],
            [-74.016218975, 40.637868876],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1829",
      },
    },
    {
      type: "Feature",
      id: "sm6dd186fe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012698995, 40.637857839],
            [-74.01270772, 40.633335961],
            [-74.009059232, 40.633331907],
            [-74.009050522, 40.637846399],
            [-74.012698995, 40.637857839],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1828",
      },
    },
    {
      type: "Feature",
      id: "sm162f8578",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009050522, 40.637846399],
            [-74.009059232, 40.633331907],
            [-74.0054967, 40.633327949],
            [-74.005488004, 40.637835228],
            [-74.009050522, 40.637846399],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1827",
      },
    },
    {
      type: "Feature",
      id: "sm50535089",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005488004, 40.637835228],
            [-74.0054967, 40.633327949],
            [-74.002320846, 40.63332442],
            [-74.002312162, 40.63782527],
            [-74.005488004, 40.637835228],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1826",
      },
    },
    {
      type: "Feature",
      id: "sm3a51f991",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002312162, 40.63782527],
            [-74.002320846, 40.63332442],
            [-73.998458473, 40.633320128],
            [-73.998449805, 40.637813159],
            [-74.002312162, 40.63782527],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1825",
      },
    },
    {
      type: "Feature",
      id: "sm6d5dc6f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998449805, 40.637813159],
            [-73.998458473, 40.633320128],
            [-73.994853718, 40.633316123],
            [-73.994845063, 40.637801856],
            [-73.998449805, 40.637813159],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1824",
      },
    },
    {
      type: "Feature",
      id: "sm00803f0b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994845063, 40.637801856],
            [-73.994853718, 40.633316123],
            [-73.991291878, 40.633312165],
            [-73.991283237, 40.637790687],
            [-73.994845063, 40.637801856],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1823",
      },
    },
    {
      type: "Feature",
      id: "smf1a91434",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.991283237, 40.637790687],
            [-73.991291878, 40.633312165],
            [-73.987944488, 40.633308446],
            [-73.98793586, 40.637780191],
            [-73.991283237, 40.637790687],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1822",
      },
    },
    {
      type: "Feature",
      id: "smfef1a4f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.98793586, 40.637780191],
            [-73.987944488, 40.633308446],
            [-73.984339737, 40.633304441],
            [-73.984316484, 40.637768842],
            [-73.98793586, 40.637780191],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1821",
      },
    },
    {
      type: "Feature",
      id: "sma66f6d1d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049352645, 40.631658218],
            [-74.051931087, 40.631653622],
            [-74.052639191, 40.631067378],
            [-74.05255336, 40.626882099],
            [-74.05255336, 40.626882099],
            [-74.049356276, 40.626880699],
            [-74.049352645, 40.631658218],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1857",
      },
    },
    {
      type: "Feature",
      id: "sm1d08f24b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049356276, 40.626880699],
            [-74.046266645, 40.626879347],
            [-74.046263009, 40.631663726],
            [-74.049352645, 40.631658218],
            [-74.049356276, 40.626880699],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1856",
      },
    },
    {
      type: "Feature",
      id: "sm3f8a973e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046266645, 40.626879347],
            [-74.042876334, 40.626877863],
            [-74.042872692, 40.631669769],
            [-74.046263009, 40.631663726],
            [-74.046266645, 40.626879347],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1855",
      },
    },
    {
      type: "Feature",
      id: "sm0f3319e6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.042876334, 40.626877863],
            [-74.039743391, 40.626876492],
            [-74.039739744, 40.631675353],
            [-74.042872692, 40.631669769],
            [-74.042876334, 40.626877863],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1854",
      },
    },
    {
      type: "Feature",
      id: "smddb427d9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039743391, 40.626876492],
            [-74.03648185, 40.626875065],
            [-74.036478199, 40.631681167],
            [-74.039739744, 40.631675353],
            [-74.039743391, 40.626876492],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1853",
      },
    },
    {
      type: "Feature",
      id: "smca279af2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03648185, 40.626875065],
            [-74.033220063, 40.626873638],
            [-74.033216405, 40.631686981],
            [-74.036478199, 40.631681167],
            [-74.03648185, 40.626875065],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1852",
      },
    },
    {
      type: "Feature",
      id: "sm6fe7d777",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.033220063, 40.626873638],
            [-74.02978691, 40.626872135],
            [-74.029783247, 40.631693101],
            [-74.033216405, 40.631686981],
            [-74.033220063, 40.626873638],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1851",
      },
    },
    {
      type: "Feature",
      id: "smb381d371",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02978691, 40.626872135],
            [-74.026654091, 40.626870764],
            [-74.026650423, 40.631698685],
            [-74.029783247, 40.631693101],
            [-74.02978691, 40.626872135],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1850",
      },
    },
    {
      type: "Feature",
      id: "sm1795cfc8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.026654091, 40.626870764],
            [-74.02335023, 40.626869318],
            [-74.023346556, 40.631704574],
            [-74.026650423, 40.631698685],
            [-74.026654091, 40.626870764],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1849",
      },
    },
    {
      type: "Feature",
      id: "sme23ca135",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02335023, 40.626869318],
            [-74.0203024, 40.626867984],
            [-74.020298721, 40.631710007],
            [-74.023346556, 40.631704574],
            [-74.02335023, 40.626869318],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1848",
      },
    },
    {
      type: "Feature",
      id: "sm857f9ebe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0203024, 40.626867984],
            [-74.016955128, 40.626866519],
            [-74.016951443, 40.631715974],
            [-74.020298721, 40.631710007],
            [-74.0203024, 40.626867984],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1847",
      },
    },
    {
      type: "Feature",
      id: "sm5c0c4b5c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016955128, 40.626866519],
            [-74.013779369, 40.626865129],
            [-74.013775679, 40.631721635],
            [-74.016951443, 40.631715974],
            [-74.016955128, 40.626866519],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1846",
      },
    },
    {
      type: "Feature",
      id: "sm93612000",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013779369, 40.626865129],
            [-74.010303326, 40.626863608],
            [-74.01029963, 40.631727831],
            [-74.013775679, 40.631721635],
            [-74.013779369, 40.626865129],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1845",
      },
    },
    {
      type: "Feature",
      id: "sm01d8547f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010303326, 40.626863608],
            [-74.007256139, 40.626862274],
            [-74.007252438, 40.631733263],
            [-74.01029963, 40.631727831],
            [-74.010303326, 40.626863608],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1844",
      },
    },
    {
      type: "Feature",
      id: "sm353db8be",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007256139, 40.626862274],
            [-74.003908843, 40.626860809],
            [-74.003905136, 40.63173923],
            [-74.007252438, 40.631733263],
            [-74.007256139, 40.626862274],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1843",
      },
    },
    {
      type: "Feature",
      id: "sm7f16745d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003908843, 40.626860809],
            [-74.000604288, 40.626859363],
            [-74.000600576, 40.631745121],
            [-74.003905136, 40.63173923],
            [-74.003908843, 40.626860809],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1842",
      },
    },
    {
      type: "Feature",
      id: "sm2115e6bc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.000604288, 40.626859363],
            [-73.997514582, 40.626858011],
            [-73.997510865, 40.631750629],
            [-74.000600576, 40.631745121],
            [-74.000604288, 40.626859363],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1841",
      },
    },
    {
      type: "Feature",
      id: "sm00a6cebd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997514582, 40.626858011],
            [-73.994081554, 40.626856508],
            [-73.994077831, 40.631756749],
            [-73.997510865, 40.631750629],
            [-73.997514582, 40.626858011],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1840",
      },
    },
    {
      type: "Feature",
      id: "sm198774a5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994081554, 40.626856508],
            [-73.990948242, 40.626855137],
            [-73.990944513, 40.631762334],
            [-73.994077831, 40.631756749],
            [-73.994081554, 40.626856508],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1839",
      },
    },
    {
      type: "Feature",
      id: "smd9c9834c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.990948242, 40.626855137],
            [-73.987729691, 40.626853728],
            [-73.987725957, 40.631768071],
            [-73.990944513, 40.631762334],
            [-73.990948242, 40.626855137],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1838",
      },
    },
    {
      type: "Feature",
      id: "smf021ba5f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.987729691, 40.626853728],
            [-73.984596896, 40.626852357],
            [-73.984593157, 40.631773655],
            [-73.987725957, 40.631768071],
            [-73.987729691, 40.626853728],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1837",
      },
    },
    {
      type: "Feature",
      id: "sme353e7b4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.984596896, 40.626852357],
            [-73.981163893, 40.626850854],
            [-73.981160148, 40.631779774],
            [-73.984593157, 40.631773655],
            [-73.984596896, 40.626852357],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1836",
      },
    },
    {
      type: "Feature",
      id: "smd62202ae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.981163893, 40.626850854],
            [-73.978138154, 40.62684953],
            [-73.978095238, 40.631197656],
            [-73.978846257, 40.631783899],
            [-73.981160148, 40.631779774],
            [-73.981163893, 40.626850854],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1835",
      },
    },
    {
      type: "Feature",
      id: "sm24f43382",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.126336343, 40.631762795],
            [-74.130015558, 40.631767615],
            [-74.131088441, 40.631018526],
            [-74.130959695, 40.626719245],
            [-74.130959695, 40.626719245],
            [-74.126317608, 40.626729197],
            [-74.126336343, 40.631762795],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1880",
      },
    },
    {
      type: "Feature",
      id: "sm43d9b7ea",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.126317608, 40.626729197],
            [-74.123058129, 40.626736185],
            [-74.123076822, 40.631758525],
            [-74.126336343, 40.631762795],
            [-74.126317608, 40.626729197],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1879",
      },
    },
    {
      type: "Feature",
      id: "smed3ca0f3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.123058129, 40.626736185],
            [-74.11939138, 40.626744046],
            [-74.119410026, 40.631753721],
            [-74.123076822, 40.631758525],
            [-74.123058129, 40.626736185],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1878",
      },
    },
    {
      type: "Feature",
      id: "smeb5475d8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11939138, 40.626744046],
            [-74.116408181, 40.626750442],
            [-74.116426789, 40.631749813],
            [-74.119410026, 40.631753721],
            [-74.11939138, 40.626744046],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1877",
      },
    },
    {
      type: "Feature",
      id: "sm5d746cc5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.116408181, 40.626750442],
            [-74.112866786, 40.626758035],
            [-74.112885349, 40.631745174],
            [-74.116426789, 40.631749813],
            [-74.116408181, 40.626750442],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1876",
      },
    },
    {
      type: "Feature",
      id: "sm2a206bb9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.112866786, 40.626758035],
            [-74.109778119, 40.626764657],
            [-74.109796641, 40.631741128],
            [-74.112885349, 40.631745174],
            [-74.112866786, 40.626758035],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1875",
      },
    },
    {
      type: "Feature",
      id: "sm62a25f72",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.109778119, 40.626764657],
            [-74.106302003, 40.62677211],
            [-74.106320482, 40.631736574],
            [-74.109796641, 40.631741128],
            [-74.109778119, 40.626764657],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1874",
      },
    },
    {
      type: "Feature",
      id: "sm02b3e101",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.106302003, 40.62677211],
            [-74.103426092, 40.626778276],
            [-74.103444533, 40.631732807],
            [-74.106320482, 40.631736574],
            [-74.106302003, 40.62677211],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1873",
      },
    },
    {
      type: "Feature",
      id: "sm8ee2a3cd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.103426092, 40.626778276],
            [-74.100079449, 40.626785451],
            [-74.100097848, 40.631728423],
            [-74.103444533, 40.631732807],
            [-74.103426092, 40.626778276],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1872",
      },
    },
    {
      type: "Feature",
      id: "sm008a6170",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.100079449, 40.626785451],
            [-74.096949685, 40.626792161],
            [-74.096968042, 40.631724323],
            [-74.100097848, 40.631728423],
            [-74.100079449, 40.626785451],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1871",
      },
    },
    {
      type: "Feature",
      id: "sma64288e5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.096949685, 40.626792161],
            [-74.093515636, 40.626799523],
            [-74.093533949, 40.631719824],
            [-74.096968042, 40.631724323],
            [-74.096949685, 40.626792161],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1870",
      },
    },
    {
      type: "Feature",
      id: "sm9496ca15",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.093515636, 40.626799523],
            [-74.090554986, 40.62680587],
            [-74.090573261, 40.631715945],
            [-74.093533949, 40.631719824],
            [-74.093515636, 40.626799523],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1869",
      },
    },
    {
      type: "Feature",
      id: "sm40e03fdd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.090554986, 40.62680587],
            [-74.087078386, 40.626813324],
            [-74.087096616, 40.631711391],
            [-74.090573261, 40.631715945],
            [-74.090554986, 40.62680587],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1868",
      },
    },
    {
      type: "Feature",
      id: "sm574abd1b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.087078386, 40.626813324],
            [-74.083900857, 40.626820136],
            [-74.083919047, 40.631707228],
            [-74.087096616, 40.631711391],
            [-74.087078386, 40.626813324],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1867",
      },
    },
    {
      type: "Feature",
      id: "sm09104a13",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083900857, 40.626820136],
            [-74.080595917, 40.626827222],
            [-74.080614064, 40.631702898],
            [-74.083919047, 40.631707228],
            [-74.083900857, 40.626820136],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1866",
      },
    },
    {
      type: "Feature",
      id: "sm2a830d10",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.080595917, 40.626827222],
            [-74.077419479, 40.626834032],
            [-74.077437586, 40.631698737],
            [-74.080614064, 40.631702898],
            [-74.080595917, 40.626827222],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1865",
      },
    },
    {
      type: "Feature",
      id: "smad286ca2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077419479, 40.626834032],
            [-74.074115388, 40.626841116],
            [-74.074133452, 40.631694409],
            [-74.077437586, 40.631698737],
            [-74.077419479, 40.626834032],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1864",
      },
    },
    {
      type: "Feature",
      id: "smf669d608",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.074115388, 40.626841116],
            [-74.07094186, 40.62684792],
            [-74.070959884, 40.631690252],
            [-74.074133452, 40.631694409],
            [-74.074115388, 40.626841116],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1863",
      },
    },
    {
      type: "Feature",
      id: "sm912da243",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07094186, 40.62684792],
            [-74.067681896, 40.626854909],
            [-74.067699878, 40.631685981],
            [-74.070959884, 40.631690252],
            [-74.07094186, 40.62684792],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1862",
      },
    },
    {
      type: "Feature",
      id: "smf4edfc2d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067681896, 40.626854909],
            [-74.064462665, 40.626861811],
            [-74.064480605, 40.631681764],
            [-74.067699878, 40.631685981],
            [-74.067681896, 40.626854909],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1861",
      },
    },
    {
      type: "Feature",
      id: "sm9bd29fed",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.064462665, 40.626861811],
            [-74.061115416, 40.626868987],
            [-74.061133313, 40.631677379],
            [-74.064480605, 40.631681764],
            [-74.064462665, 40.626861811],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1860",
      },
    },
    {
      type: "Feature",
      id: "sm588c6378",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.061115416, 40.626868987],
            [-74.057767076, 40.626876166],
            [-74.05778493, 40.631672993],
            [-74.061133313, 40.631677379],
            [-74.061115416, 40.626868987],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1859",
      },
    },
    {
      type: "Feature",
      id: "sm29db3dc4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057767076, 40.626876166],
            [-74.054999535, 40.626882099],
            [-74.054913704, 40.630985955],
            [-74.055428688, 40.631669906],
            [-74.05778493, 40.631672993],
            [-74.057767076, 40.626876166],
          ],
        ],
      },
      properties: {
        Unit_Number: "MK1858",
      },
    },
  ],
};

export default geojsonData;
